<template>
  <div class="page-wrapper">
<!--    <div class="container-fluid">-->
<!--      <div class="row">-->
<!--        <div class="col-3 text-left" style="padding-top:10px;padding-bottom: 10px; background-color: #E0E0E0;">-->

<!--        </div>-->
<!--        <div class="col-9 text-right" style="padding-top:10px;padding-bottom: 10px; background-color: #E0E0E0;">-->

<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="flex-wrapper">
      <div class="menu-container">
        <strong>Select Delivery Date</strong>
        <input type="date" class="form-control" v-model="selectedDateFrom"/>
        <input type="date" class="form-control" v-model="selectedDateTo"/>
        <select class="form-control" v-model="selectedMerchantId">
          <option value="0">All Shops</option>
          <option v-for="m in merchants" :value="m.id">{{m.title}} <span v-if="m.active === false"> (Inactive)</span></option>
        </select>
        <div class="kh-btn kh-btn-smaller kh-4" v-on:click="getDayOrderList">Get</div>

        <br/>
        <br/>
        <br/>

        <div class="kh-btn kh-btn-smaller kh-6" v-on:click="getTodayOrderList(0)">Today's Orders</div>
        <br/>
        <br/>

        <div class="kh-btn kh-btn-smaller kh-11" v-on:click="getTodayOrderList(1)">Tomorrow's Orders</div>
        <br/>
        <br/>

        <div v-if="user.manageOrder === true">
          <input type="text" class="form-control" v-model="searchInvoice" @change="searchOrderWithInvoice"/>
          <div class="kh-btn kh-btn-smaller kh-10" @click="searchOrderWithInvoice">Search INV</div>
        </div>
        <br>
        <br/>
        <br/>
        <div class="kh-btn kh-btn-smaller kh-6" v-on:click="downloadOrderList">Order Excel</div>

        <br><br><br><br>
<!--        <strong>Search Filter</strong>-->
<!--        <select class="form-control" v-model="selectedMerchantId">-->
<!--          <option value="0">All Shops</option>-->
<!--          <option v-for="m in merchants" :value="m.id">{{m.title}} <span v-if="m.active === false"> (Inactive)</span></option>-->
<!--        </select>-->

<!--        Created date<br/>-->
<!--        From-->
<!--        <input type="date" class="form-control" v-model="dateFrom"/>-->
<!--        To-->
<!--        <input class="form-control" type="date" v-model="dateTo"/>-->
<!--        Status-->
<!--        <select v-model="selectedState" class="form-control">-->
<!--          <option value="-1000">All</option>-->
<!--          <option v-for="(s, si) in stateList" :value="si">{{s.title}}</option>-->
<!--        </select>-->

<!--        <button class="btn kh-4 form-control" v-on:click="getOrderList">Search</button>-->

        <br>
        <br>
        <input type="date" class="form-control" v-model="itemDate"/>
        <div class="kh-btn kh-btn-smaller kh-1" v-on:click="showAllItemsToBeAccepted">Order Items</div>
      </div>
      <div class="list-container">


        <table class="table">
          <tr>
            <th>#<span v-if="orders.length > 0">{{orders.length}}</span></th>
            <th><span v-on:click="sortByInvoiceNumber">Invoice <i class="fas fa-sort"></i></span></th>
            <th style="width: 120px; max-width: 120px;">Delivery Note</th>

            <th class="text-left"><span v-on:click="sortByShopName">Shop <i class="fas fa-sort"></i></span></th>
            <th style="min-width: 150px;"><span v-on:click="sortByOrderedDate">Ordered Date <i class="fas fa-sort"></i></span></th>
            <th style="min-width: 150px;"><span v-on:click="sortByDeliveryDate">Delivery Date <i class="fas fa-sort"></i></span></th>
            <th class="text-right">Due</th>
            <th class="text-right">Paid</th>
            <th style="min-width: 150px;"><span v-on:click="sortByState">Status <i class="fas fa-sort"></i></span></th>
            <th><span v-on:click="sortByDriver">Driver<i class="fas fa-sort"></i></span></th>
            <th>Shift</th>
            <th style="min-width: 150px;"><span v-on:click="sortByDeliveredDate">Delivery <i class="fas fa-sort"></i></span></th>
          </tr>
          <tbody v-for="(order, oi) in orders" >
            <tr v-on:click="onItemClicked(order.id)"  :class="'order-item-state-'+ order.state + ' hover-item'" >
              <td>{{order.id}}</td>

              <td>
                <strong>
                  <span v-if="order.invoice != null && user.manageOrder === true" v-on:click.stop="openInvoiceView(order.id)"><span v-if="order.invoice.title != null && order.invoice.title.length > 0">{{order.invoice.title}}</span><i v-else class="fas fa-file-alt" style="color:green;"></i> </span>
                </strong>
              </td>
              <td style="width: 120px; max-width: 120px;"><span v-if="order.deliveryNotes != null && order.deliveryNotes.length > 0" v-on:click.stop="deliveryNoteView = order"><i class="fas fa-file-alt" style="color:blue;"></i></span></td>
              <td class="text-left">{{getMerchantName(order.merchantId)}} <span v-if="order.orderFrom === 'GUAC'">(<img style="height: 20px;" src="https://cdn.prod.website-files.com/66d5b8ea4fb61574497d60ff/66d6f3945a9a89763f7e68dc_Guac%20logo.svg"/>)</span></td>
              <td>{{dateString(order.createdTimestamp, '-')}}</td>
              <td>
                {{convertDeliveryDate(order.deliveryDate)}}
<!--                {{order.deliveryDate}} <span v-if="order.deliveryDate !== null && order.deliveryDate.length === 10">{{getDayOfWeek(order.deliveryDate)}}</span>-->
              </td>
              <td class="text-right"><span v-if="user.manageOrder === true">{{(order.finalDue/100).toFixed(2)}}</span></td>
              <td class="text-right"><span v-if="user.manageOrder === true">{{(order.paid/100).toFixed(2)}}</span></td>
              <td>
                {{orderStateString(order.state)}}
                <div class="progress-container" style="display: flex; justify-content: center; display: none;" v-if="order.state >= 0">
                  <ul style="list-style: none;">
                    <template v-for="(s, si) in stateList" v-if="s.progress != undefined && s.progress == true">
                      <li class="progress-item" v-bind:class="{'activated': order.state >= s.state}">{{s.title}}</li>
  <!--                    <li class="progress-item" v-if="si >= 0">-->
  <!--                      <span><i class="fas fa-arrow-right"></i></span>-->
  <!--                    </li>-->
                    </template>
                    <li class="progress-item" v-bind:class="{'activated': order.paid >= order.finalDue}">Payment</li>
                  </ul>
                </div>
                <div v-else style="color:red; display: none;">
                  {{orderStateString(order.state)}}
                </div>

<!--                <select v-model="order.state" disabled="false">-->
<!--                  <option v-for="s in stateList" :value="s.state">{{s.title}}</option>-->
<!--                </select>-->
              </td>
              <td @click.stop="dummy">
                <select v-if="order.state >= 0 && order.state < 60 && (user.manageOrder === true || user.manageOrderDriver === true)" v-model="order.driverId" class="driver-selector" @change="onDriverChanged(order)">
                  <option value="0">No Driver</option>
                  <option v-for="driver in drivers" :key="'order-' + order.id + '-driver-selector-'+driver.id" :value="driver.id">{{getDriverName(driver.id)}}</option>
                </select>
                <div v-else>
                  <span v-if="order.driverId > 0">{{getDriverName(order.driverId)}}</span>
                  <span v-else style="font-weight: bold; color:red;">No Driver</span>
                </div>
              </td>
              <td>
                {{getShiftText(order.deliveryShift)}}
              </td>
              <td>
                <span v-if="order.delivered===true">Delivered</span>
              </td>
            </tr>
          </tbody>
          <tbody v-if="isAdmin() == true">
          <tr v-if="user !== null && user.manageOrder === true">
            <td colspan="2">New</td>
            <td>
              <select class="form-control" v-model="newOrderMerchantId">
                <option value="0">Select Shop</option>
                <option v-for="m in merchants" :value="m.id" :disabled="m.active === false">{{m.title}}</option>
              </select>
            </td>
            <td>
              <input type="date" class="form-control" v-model="newOrderDeliveryDate"/>
            </td>
            <td colspan="2">
              <span class="form-control" v-on:click="createNewOrder"><i class="fas fa-plus-circle"></i> Create</span>
            </td>
            <td colspan="2">
              To create new order, select merchant and date, then click New Order button
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <transition name="slideup">
        <div class="item-container" v-if="currentOrder != false" v-on:click="closeCurrentOrder(true)">
          <div class="item-wrapper"  style="border-radius: 10px; box-shadow: 5px 5px 20px black;" v-on:click.stop="dummy">
            <div class="item-header" style="position: sticky; top:0; z-index: 2; background-color: #A9E1FF;">
              <span style="float:left; height:38px; line-height: 38px; font-weight: bold; font-size: 20px;">#{{currentOrder.id}} {{getMerchantName(currentOrder.merchantId)}}</span>

<!--              <button class="btn btn-primary" style="float:right;" v-on:click="refreshItem(currentOrder.id)">Refresh</button>-->
              <button class="btn btn-dark" style="float:right; margin-right:10px;" v-on:click="closeCurrentOrder(true)">Close</button>
              <button class="btn btn-success" style="float:right; margin-right:10px;" v-on:click="getHistory('Order History', 'Order Number ' + currentOrder.id, 'orderId='+currentOrder.id)"><i class="fas fa-history"></i> History</button>
            </div>
            <div class="item-body text-left">
              <table class="text-left order-info-table" style="margin-top: 20px;">
                <tr>
                  <td style="padding-left:10px;">Shop:</td>
                  <td>{{getMerchantName(currentOrder.merchantId)}}</td>
                </tr>
                <tr v-if="currentOrder.version !== undefined && currentOrder.version !== null && currentOrder.version.length > 0">
                  <td style="padding-left:10px;">App Version:</td>
                  <td>{{currentOrder.version}}</td>
                </tr>
                <tr v-if="currentOrder.orderFrom === 'GUAC'">
                  <td style="padding-left:10px;">
                    Ordered By
                  </td>
                  <td>
                    <span ><img style="height: 20px;" src="https://cdn.prod.website-files.com/66d5b8ea4fb61574497d60ff/66d6f3945a9a89763f7e68dc_Guac%20logo.svg"/></span>
                  </td>

                </tr>
                <tr>
                  <td style="padding-left:10px;">Ordered Time:</td>
                  <td>{{timeString(currentOrder.createdTimestamp)}}</td>
                </tr>
                <tr>
                  <td style="padding-left:10px;">Delivery Date:</td>
                  <td>
                    <input type="date" v-model="currentOrder.deliveryDate" @change="onOrderChanged" :disabled="user.manageOrder === false || currentOrder.state >= 100"/>
                    <span style="margin-left: 20px;" v-if="currentOrder.deliveryDate !== null">{{getDayOfWeek(currentOrder.deliveryDate)}}</span>
                  </td>
                </tr>
                <tr>
                  <td style="padding-left:10px;">Report Date:</td>
                  <td>{{convertDate(currentOrder.reportDate)}}</td>
                </tr>
                <tr>
                  <td style="padding-left:10px;">Status </td>
                  <td style="padding-top: 10px;">
                    <div v-if="currentOrder.state >= 0" class="progress-container" style="display: flex; justify-content: center;">
                      <ul style="list-style: none;">
                        <template v-for="(s, si) in stateList" v-if="s.progress !== undefined && s.progress === true">
                          <li class="progress-item" v-bind:class="{'activated': currentOrder.state >= s.state}">{{s.title}}</li>
                          <!--                    <li class="progress-item" v-if="si >= 0">-->
                          <!--                      <span><i class="fas fa-arrow-right"></i></span>-->
                          <!--                    </li>-->
                        </template>
                        <li class="progress-item" v-bind:class="{'activated': currentOrder.paid >= currentOrder.finalDue}">Payment</li>
                      </ul>
                    </div>
                    <div v-else style="color:red;">
                      {{orderStateString(currentOrder.state)}}
                    </div>
<!--                    <select v-model="currentOrder.state" disabled="true">-->
<!--                      <option v-for="s in stateList" :value="s.state">{{s.title}}</option>-->
<!--                    </select>-->
                  </td>
                </tr>
                <tr>
                  <td style="padding-left:10px;">Method:</td>
                  <td>
                    <select v-model="currentOrder.deliveryMethod"  :disabled="user.manageOrder === false || currentOrder.state >= 100">
                      <option value="delivery">Delivery</option>
                      <option value="collection">Collection</option>
                    </select>
                  </td>
                </tr>
                <template v-if="currentOrder.deliveryMethod === 'delivery'">
                <tr>
                  <td style="padding-left:10px;">Driver:</td>
                  <td>
                    <select v-model="currentOrder.driverId" @change="onDriverChange" :disabled="user.manageOrder === false || currentOrder.state >= 100 || currentOrder.delivered === true">
                      <option value="0">Select Driver</option>
                      <option v-for="driver in drivers" :value="driver.id">{{driver.name}}</option>
                    </select>
                  </td>
                </tr>
                <tr v-if="currentOrder.delivered == true" >
                  <td style="padding-left:10px; padding-top:10px; vertical-align: top;"></td>
                  <td style="padding-top:10px;">
                    <button class="btn btn-dark" v-on:click="currentOrder.delivered = !currentOrder.delivered"><span v-if="currentOrder.delivered">Delivered</span><span v-else>To be Delivered</span></button>
                    at {{timeString(currentOrder.deliveredTime)}} Signed by {{currentOrder.signatureName}}
                    <br><span><img :src="currentOrder.signatureUrl" width="300px" style="border:1px solid grey;"/></span>
                  </td>

                </tr>
                </template>
                <template v-else-if="currentOrder.deliveryMethod === 'collection'">
                  <td style="padding-left:10px;">Collection</td>
                  <td>
                    <button class="btn btn-dark" v-on:click="currentOrder.delivered = !currentOrder.delivered"><span v-if="currentOrder.delivered">Collected</span><span v-else>To be Collected</span></button>
                    <input type="text" v-model="currentOrder.signatureName" :disabled="user.type !== 'ROLE_ADMIN' || currentOrder.state >= 100"/>
                    <span style="margin-left:20px;"> When: </span>
                    <date-picker v-model="currentOrder.deliveredTime" valueType="timestamp" type="datetime"></date-picker>
                    <button class="btn btn-success" @click="collectedNow"> Set to Now</button>
                    <button class="btn btn-primary" @click="onCollectionUpdate">Save Collection</button>
                  </td>
                </template>

              </table>
<!--              <div>-->

<!--              </div>-->
<!--              <div class="section-header">Details</div>-->
              <table class="table" style="font-size: small; margin-top: 20px;">
                <tr class="stick-top-row" style="border-top: 2px solid #ccc;">
                  <th class="text-left"><span v-if="currentOrder.list.length > 0">{{currentOrder.list.length}} items</span><span v-else>Item</span></th>
                  <th class="hide">Original Price</th>
                  <th class="hide">Margin</th>
                  <th class="hide">Merchant Price</th>
                  <th><span v-if="user.editOrderDiscount === true">DC %</span></th>
<!--                  <th><span  v-if="user.editOrderDiscount === true">DC £</span></th>-->
                  <th class="text-center" style="padding-left:0;padding-right:0;">Order Qty</th>
                  <th class="text-center">Qty</th>
                  <th>
<!--                    <span  v-if="user.viewProductCost === true">원가</span>-->
                  </th>
                  <th><span  v-if="user.manageOrder === true">판매가</span></th>
                  <th><span  v-if="user.manageOrder === true">Price</span></th>
                  <th><span  v-if="user.manageOrder === true">Total</span></th>
                  <th><span  v-if="user.manageOrder === true">VAT</span></th>


                  <th><span v-if="currentOrder.state >= 0 && currentOrder.state < 18">Stock</span></th>
                  <th>Kg</th>
                  <th>State</th>
                  <th></th>

  <!--                <th>Status</th>-->
                </tr>
                <template v-for="(item, ii) in currentOrder.list">
                  <tr :key="'order-item-category-' + item.id"  v-if="ii === 0 || item.categoryTitle !== currentOrder.list[ii-1].categoryTitle">
                    <td colspan="14" class="category-title" >{{item.categoryTitle}}</td>
                  </tr>
                  <tbody v-if="item.id > 0" v-bind:class="{['order-item-state-' + item.state]: true,
                  'order-item-low-stock': item.state >= 0 && item.state < 20 && item.product != null && item.amount > item.product.currentStock,
                   'full-confirmed': item.state >=12 && item.state <=15 && item.midStockQuantity === item.amount,
                   'partial-confirmed': item.midStockQuantity > 0 && item.midStockQuantity < item.amount}">

                    <tr class="order-item-row" v-bind:class="{'item-cancelled':item.state < 0}">
                      <td class="text-left">
                        <strong>{{item.title}}</strong>
                        <div v-if="item.tags !== null && item.tags.length > 0">
                          <span v-for="t in item.tags" :key="'item-tag-'+ item.id + '-'+tag">#{{t}}</span>
                        </div>

                      </td>
                      <td class="hide">{{(item.originalPrice/100).toFixed(2)}}</td>
                      <td class="hide">{{(item.marginRate/100).toFixed(2)}}%</td>
                      <td class="hide">{{(item.merchantPrice/100).toFixed(2)}}</td>
                      <td>
                        <select v-if="user.editOrderDiscount === true" v-model="item.discountRate" v-on:change="onOrderChanged" :disabled="user.editOrderDiscount === false || currentOrder.state < 20 || currentOrder.state >= 100">
                          <option v-for="(rate, ri) in 50" :value="ri*100">{{ri}}%</option>
  <!--                        <option value="0">0%</option>-->
  <!--                        <option value="1000">10%</option>-->
  <!--                        <option value="2000">20%</option>-->
                        </select>
  <!--                      {{(item.discountAmount/100).toFixed(2)}}-->
                      </td>
<!--                      <td>-->
<!--                        <input  v-if="user.editOrderDiscount === true" type="number" style="width:70px; text-align: center;"  v-model="item.discountAmount" v-on:change="onOrderChanged" :disabled="user.editOrderDiscount === false || currentOrder.state < 0 || currentOrder.state >= 100"/>-->
<!--                      </td>-->
                      <td class="text-center" style="padding-left:0;padding-right:0;">{{item.orderedAmount}} </td>
                      <td class="text-center">

                        <input v-if="item.state === 0 && user.editOrder === true" type="number" v-model="item.amount" style="width:70px; text-align: center;" v-on:change="onOrderChanged" :disabled="user.type !== 'ROLE_ADMIN' || currentOrder.state > 0 || currentOrder.delivered === true"/>

  <!--                      <span class="hover-number" v-else-if="item.state < 20 && currentOrder.delivered === false" v-on:click="showItemAmountChange(item)">{{item.amount}}</span>-->
                        <span v-else>{{item.amount}}</span>
      <!--                  {{item.amount}}-->
                      </td>
                      <td>
<!--                        <span  v-if="user.viewProductCost === true">{{(item.originalPrice/100).toFixed(2)}}</span>-->
                      </td>
                      <td><span v-if="user.manageOrder === true">{{(item.merchantPrice/100).toFixed(2)}}</span></td>
                      <td>
                        <div  v-if="user.manageOrder === true">

                          <input v-if="item.state > 18 && item.state < 100" v-model="item.priceFloat" style="width:100px;" @change="onPriceChanged(ii)"/>
                          <div v-else>
                            <span v-if="item.originalPrice > item.price"><i style="color:red;" class="fas fa-exclamation-circle"></i></span>{{(item.price/100).toFixed(2)}}
                          </div>
                        </div>
                      </td>
                      <td>
                        <span  v-if="user.manageOrder === true">
                          {{(item.totalPrice/100).toFixed(2)}}
                        </span>
                      </td>
                      <td><span  v-if="user.manageOrder === true">{{(item.taxRate/100).toFixed(0)}}% ({{(item.tax/100).toFixed(2)}})</span></td>

                      <td><span v-if="item.state >= 0 && item.state < 18">{{item.inventoryQuantity}}</span></td>
                      <td>{{(item.totalWeight/100.0).toFixed(2)}}</td>
                      <td><span v-if="item.midStockQuantity > 0"><b>{{item.midStockQuantity}}</b></span> {{item.stateText}}</td>
                      <td>
  <!--                      <span v-if="item.state == 0" v-on:click="confirmOrderItem(item.id)"><i class="far fa-check-circle" style="color:grey;"></i></span>-->
  <!--                      <span v-else-if="item.state >= 20"><i class="fas fa-check-circle" style="color:blue;"></i></span>-->
                        <span v-on:click="getHistory('Order Item History', 'Order Number ' + currentOrder.id + ' ' + item.description, 'orderItemId='+item.id)" style="margin-right:10px;"><i class="fas fa-history"></i></span>
                        <span v-if="user.editOrder === true && item.state === 0 && currentOrder.delivered === false" v-on:click="cancelOrderItem(item)" style="margin-left:10px;"><i class="fas fa-times" style="color:red;"></i></span>
                        <span v-on:click="getOrderTracking(item.id)" style="margin-right:10px;">Track</span>

      <!--                  <span v-if="item.confirmedAmount > 0">{{item.confirmedAmount}}</span><span v-else >Confirm</span></td>-->
                        <span v-if="item.state === 100 && user.manageCredit === true && item.amount > 0" style="margin-left: 30px; padding-left: 10px; padding-right: 10px;" @click="showCreditForm(item)">Credit</span>
                      </td>

      <!--                <td>-->
      <!--                  {{orderStateString(item.state)}}-->
      <!--                  <select v-model="item.state" class="form-control" style="display: none;">-->
      <!--                    <option value="0">To Be Confirmed</option>-->
      <!--                    <option value="20">Confirmed</option>-->
      <!--                    <option value="-100">Reject</option>-->
      <!--                  </select>-->
      <!--                </td>-->
                    </tr>
                    <template v-if="item.useVariablePrice === true && user.manageOrder === true">
                      <tr>
                        <td></td>
                        <td ></td>
                        <td ></td>

                        <td class="text-right">
                          <input type="number" style="width:80px; text-align: center" :class="{'warning-input': item.variablePriceAmount >= 10000}" v-model="item.variablePriceAmountFloat" @change="onOrderChanged" :disable="user.editOrder === false || item.state < 0 || item.state >= 30"  :disabled="user.type !== 'ROLE_ADMIN' || currentOrder.state >= 100"/>kg
                        </td>
                        <td class="text-center">X</td>
                        <td>
                          £ <input type="number" style="width:70px;" v-model="item.variablePricePerUnitFloat" @change="onOrderChanged" :disable="user.editOrder === false || item.state < 0 || item.state >= 30" />/kg
                        </td>
                        <td/>

                        <td/>
                        <td/>
                        <td/>
                        <td/>
                        <td/>
                        <td/>
                      </tr>
                    </template>
                    <template v-if="item.notes != undefined && item.notes != null && item.notes.length > 0">
                      <tr class="memo-row" >
                        <td colspan="14" class="text-left">
                          <div class="memo-container">
                            <div class="memo-item" v-for="note in item.notes">
                              <div class="memo-header">
                                <strong>{{note.userName}}'s note: </strong> @{{timeString(note.createdTimestamp)}} [{{note.id}}]
                                <span v-if="note.userId == user.id" v-on:click="askRemoveNote(note)"><i class="fas fa-trash"></i></span>
                                <br>
                                <span class="note-receiver" v-if="note.toAll == true"> <i class="fas fa-users" style="color:green;"></i></span><span class="note-receiver" v-if="note.toShop == true"> <i class="fas fa-store-alt" style="color:red;"></i></span><span class="note-receiver" v-if="note.toDriver == true"> <i class="fas fa-truck" style="color:blue;"></i></span>
                              </div>
                              <div class="memo-content">

                              {{note.description}}
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>

                    </template>
                    <tr class="memo-row" v-if="user.editOrder === true  && currentOrder.state >= 0 && currentOrder.state < 100">

                      <td colspan=14 style="padding-bottom: 5px;">
                        <input class="form-control" v-model="item.note" v-on:change="onItemNoteAdded(ii)" placeholder="Type memo and press enter key"/>
                      </td>
                    </tr>
                  </tbody>
                </template>
                <tbody>
                <tr v-if="user.editOrder === true && currentOrder.state >= 0 && currentOrder.state < 18">
                  <td colspan="2">
<!--                    <autocomplete-->
<!--                      :search="search"-->
<!--                      :get-result-value="getResultValue"-->
<!--                      @submit="handleSubmit"-->
<!--                      ref="autocomplete">-->

<!--                    </autocomplete>-->
                    Add Order
                    <div style="width: 100%; display: flex;">
                      <input type="text" v-model="searchWord" id="order-product-candidate-search-input" v-on:keyup="search" style="width: calc(100% - 50px)" placeholder="Search Product"/>
                      <span style="height: 30px; line-height: 30px; padding-left:10px;" v-on:click="initialiseSearch"><i class="fas fa-times"></i></span>
                    </div>
                    <ul class="autocomplete-results" v-if="candidates.length > 0">
                      <li class="autocomplete-result hover-item" v-for="(candidate, ci) in candidates" :tabindex="ci" :id="'order-product-candidate-'+ci" :key="'order-product-candidate-'+ci" v-on:keyup="moveFocusOnCandidate($event, candidate )" v-on:click.stop="selectCandidate(candidate)">
                        {{candidate.title}}
                      </li>
                    </ul>
                  </td>

                </tr>
                </tbody>
                <tr v-if="user.manageOrder === true || user.editOrderDiscount === true">
                  <th class="text-left">Total</th>

                  <th><span v-if="user.editOrderDiscount === true">{{(currentOrder.discountAmount/100).toFixed(2)}}</span></th>
                  <th></th>

                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>



                  <th>{{(currentOrder.totalPrice/100).toFixed(2)}}</th>

                  <th>{{(currentOrder.tax/100).toFixed(2)}}</th>
                  <th><strong>DUE: {{(currentOrder.finalDue/100).toFixed(2)}}</strong></th>
                  <th><strong>{{(currentOrder.totalWeight/100.0).toFixed(2)}}Kg</strong></th>
                  <th></th>
                </tr>
              </table>

              <template v-if="currentOrder.notes != undefined && currentOrder.notes != null && currentOrder.notes.length > 0">
                Order Note:
                <div class="memo-container">
                  <div class="memo-item" v-for="note in currentOrder.notes">
                    <div class="memo-header">
                      <strong>{{note.userName}}'s note: </strong> @{{timeString(note.createdTimestamp)}}
                      <span v-if="note.userId == user.id" v-on:click="askRemoveNote(note)"><i class="fas fa-trash"></i></span>
                      <br>
                      <span class="note-receiver" v-if="note.toAll == true"> <i class="fas fa-users" style="color:green;"></i></span><span class="note-receiver" v-if="note.toShop == true"> <i class="fas fa-store-alt" style="color:red;"></i></span><span class="note-receiver" v-if="note.toDriver == true"> <i class="fas fa-truck" style="color:blue;"></i></span>
                    </div>
                    <div class="memo-content">
                      {{note.description}}
                    </div>
                  </div>
                </div>
              </template>
              <input v-if="user.editOrder === true && currentOrder.state < 100" type="text" class="form-control" v-model="currentOrder.note" v-on:change="newNoteAdded" :disabled="isManager() == false" placeholder="Type memo for order and press enter key"/>


              <div class="card-footer text-right">

                <button class="btn kh-9" style="float:left;" v-if="currentOrder.state < 0 && user.cancelOrder === true" v-on:click="deleteOrder(currentOrder)">DELETE</button>
                <button class="btn kh-9" style="float:left;" v-if="currentOrder.state >= 0 && currentOrder.state < 20 && user.cancelOrder === true" v-on:click="cancelOrder(currentOrder)">Reject</button>
                <button class="btn kh-9" style="float:left;" v-if="currentOrder.state  === 100 && user.cancelOrder === true" v-on:click="uncompleteOrder(currentOrder.id)">Revert Completion</button>


<!--                <button class="btn kh-4"-->
<!--                        v-if="currentOrder.state === 0 && user.manageOrder === true"-->
<!--                        v-on:click="confirmOrder(currentOrder.id)">-->
<!--                  Confirm Order-->
<!--                </button>-->


                <div class="state-btn-container" style="padding-top:20px;">
                  <div style="width: 100%; padding-top:10px; padding-bottom:10px; display: flex;" class="text-left">
                    <div class="state-button state-active"  v-if="currentOrder.state === 100 && user.manageOrder === true">
                      <div class="state-icon" v-bind:style="{backgroundImage: 'url(/static/img/ic_order_completed.svg)'}">

                      </div>
                      <div class="state-btn-title">
                        Completed
                      </div>
                    </div>
                    <template v-else-if="((currentOrder.state >= 10 && currentOrder.state < 100 ) || currentOrder.delivered === true) && user.manageOrder === true">
                      <div class="state-button"   @click="completeOrder(currentOrder.id, false)">
                        <div class="state-icon" v-bind:style="{backgroundImage: 'url(/static/img/ic_order_completed.svg)'}">

                        </div>
                        <div class="state-btn-title">
                          Complete
                        </div>
                      </div>
                      <div class="state-button"
                           style="background: #D7FFE5;"
                           @click="completeOrder(currentOrder.id, true)">
                        <div class="state-icon" v-bind:style="{backgroundImage: 'url(/static/img/ic_order_completed.svg)'}">

                        </div>
                        <div class="state-btn-title" style="color: red;">
                          Complete and Send Invoice
                        </div>
                      </div>
                    </template>
                  </div>
                  <div style="width: 100%; padding-top:10px; padding-bottom:10px; display: none;" class="text-left" v-if="currentOrder.state === 100 && user.manageOrder === true">
                    <input style="height: 38px; line-height: 38px;" type="date" id="new-report-date"/>
                    <button class="btn btn-dark" style="margin-left:10px;" v-on:click="changeReportDate">Change Report Date</button> <span style="color:red;">(This will change accounting date for this order, items and stock dates. This may cause incorrect order of accounting report)</span>
                  </div>
  <!--                <template  v-for="state in stateList">-->
  <!--                  <div class="state-button" v-if="state.btnTitle !== undefined && state.icon !== undefined && currentOrder.state >= state.state " v-bind:class="{'state-active': currentOrder.state >= state.state}"-->

  <!--                  >-->
  <!--                    <div class="state-icon" v-bind:style="{backgroundImage: 'url(' + state.icon + ')'}">-->

  <!--                    </div>-->
  <!--                    <div class="state-btn-title">-->
  <!--                      {{state.btnTitle}}-->
  <!--                    </div>-->
  <!--                  </div>-->
  <!--                </template>-->
                  <button class="btn btn-danger" style="margin-left:100px;font-weight: bold;" v-if="currentOrder.imageUrls != null && currentOrder.imageUrls.length > 0" v-on:click="sendInvoice(currentOrder)">Send<br/>Invoice</button>
                  <button class="btn btn-primary" style="margin-left:10px;font-weight: bold;" v-if="currentOrder.imageUrls != null && currentOrder.imageUrls.length > 0" v-on:click="openInvoiceView(currentOrder.id)">View<br/>Invoice</button>

                  <button class="btn btn-primary" style="margin-left:10px;font-weight: bold;" @click="refreshItem(currentOrder.id)">Recalculate</button>
                  <button class="btn btn-primary" style="margin-left:10px;font-weight: bold;" @click="invoiceOrder(currentOrder.id)">Invoice</button>

                  <button class="btn btn-info" style="margin-left:100px;font-weight: bold;" v-if="user.manageOrder == true && (currentOrder.delivered == true || currentOrder.state >= 0) && currentOrder.state < 100" v-on:click="deliveryNote(currentOrder.id, false)">Issue<br/>Delivery Note</button>
                  <button class="btn btn-info" style="margin-left:10px;font-weight: bold;" v-if="currentOrder.deliveryNotes != null && currentOrder.deliveryNotes.length > 0" v-on:click="deliveryNote(currentOrder.id)">View<br/>Delivery Note</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="slideup">
        <div class="item-container" v-if="newNote != false" v-on:click="cancelNewNote">
          <div style="position: absolute; width: 500px; height: 500px; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;" v-on:click.stop="dummy">
            <div class="container">
              <div class="row" style="margin-top:20px;">
                <div class="col-12">
                  <h4>Add Memo</h4>
                </div>
              </div>
              <div class="row" style="margin-top:20px;">
                <div class="col-12">
                  <textarea class="form-control" v-model="newNote.description" rows="3">

                  </textarea>

                </div>
              </div>

              <div class="row" style="margin-top:20px;">
                <div class="col-4">
                  <div class="form-control plane-btn" v-bind:class="{'selected': newNote.toAll == true}" v-on:click="newNote.toAll = !newNote.toAll">To All</div>
                </div>
                <div class="col-4">
                  <div class="form-control plane-btn" v-bind:class="{'selected': newNote.toShop == true}" v-on:click="newNote.toShop = !newNote.toShop">To Shop</div>
                </div>
                <div class="col-4">
                  <div class="form-control plane-btn" v-bind:class="{'selected': newNote.toDriver == true}" v-on:click="newNote.toDriver = !newNote.toDriver">To Driver</div>
                </div>
              </div>
              <div class="row" style="margin-top:40px;">
                <div class="col-6">
                  <button class="form-control btn btn-dark" v-on:click="cancelNewNote">Cancel</button>
                </div>
                <div class="col-6">
                  <button class="form-control btn btn-primary" v-on:click="onNoteConfirmed">Add Note</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="slideup">
        <div class="item-container" v-if="changeItem != false" v-on:click="closeItemAmountChange">
          <div style="position: absolute; width: 500px; height: 500px; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;" v-on:click.stop="dummy">
            <div class="container">
              <div class="row" style="margin-top:20px;">
                <div class="col-12">
                  <h4>{{changeItem.title}}</h4>
                </div>
              </div>
              <template  v-if="changeItem.useVariablePrice == false">
                <div class="row" style="margin-top:20px;">
                  <div class="col-12">
                    Set Amount
                  </div>
                </div>

                <div class="row" style="margin-top:10px;">
                  <div class="col-4">
                    <div class="form-control" v-on:click="onItemAmountChanged(-1)">
                      <span style="color:red;"><i class="fas fa-minus-circle"></i></span>
                    </div>
                  </div>
                  <div class="col-4">
                    <input type="number" class="form-control" v-model="changeItem.amount"></input>
                  </div>
                  <div class="col-4">
                    <div class="form-control" v-on:click="onItemAmountChanged(1)">
                      <span style="color:blue;"><i class="fas fa-plus-circle"></i></span>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="row" style="margin-top:20px;">
                  <div class="col-12">
                    Set Weight
                  </div>
                </div>

                <div class="row" style="margin-top:10px;">
                  <div class="col-4">
                    <div class="form-control">
                      <span style="color:red;"><i class="fas fa-minus-circle"></i></span>
                    </div>
                  </div>
                  <div class="col-4">
                    <input type="number" class="form-control" v-model="changeItem.variablePriceAmountFloat"></input>
                  </div>
                  <div class="col-4">
                    <div class="form-control">
                      <span style="color:blue;"><i class="fas fa-plus-circle"></i></span>
                    </div>
                  </div>
                </div>
              </template>
              <div class="row" style="margin-top:40px;">
                <div class="col-6">
                  <button class="form-control btn btn-dark" v-on:click="closeItemAmountChange">Cancel</button>
                </div>
                <div class="col-6">
                  <button class="form-control btn btn-primary" v-on:click="submitItemAmountChange">Update</button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </transition>
      <transition name="slideup">
        <div class="item-container" v-if="invoiceView != false" style="z-index: 2;" v-on:click="closeInvoiceView()">
          <div style="position: absolute; width: 100%; height: 100%; top:0; left:0; background-color: white;" v-on:click.stop="dummy">

            <div style="width: 100%; height: 60px; display: flex;">
              <div style="height: 60px; line-height: 60px; width: 80px; font-size: 40px; text-align: center;">
                <i class="fas fa-file-invoice"></i>
              </div>
              <div style="height: 60px;">
                <div style="height: 35px; line-height: 35px; font-size: 20px; padding-left: 20px; font-weight: bold;">
                {{getMerchantName(invoiceView.merchantId)}} #{{invoiceView.id}} {{invoiceView.invoice.title}}
                </div>
                <div style="height: 25px; padding-left: 20px; text-align: left; font-size: 16px; color: #666; font-weight: bold;">
                  NET: £{{(invoiceView.totalPrice/100.0).toFixed(2)}} / VAT: £{{(invoiceView.tax/100.0).toFixed(2)}} / GROSS: £{{(invoiceView.finalDue/100.0).toFixed(2)}}
                </div>
              </div>
              <div  style="margin-left: auto; line-height: 60px; margin-right: 20px;">
                <button class="btn btn-danger" v-on:click="regenerateInvoice(invoiceView.id)">REGENERATE INVOICE</button>
              </div>
              <div>


                <div style="width: 60px; height: 60px; line-height: 60px; font-size: 30px; margin-right: 30px;" v-on:click="closeInvoiceView()">
                  <i class="fas fa-times" style="color:black;"></i>
                </div>
              </div>
            </div>
            <div style="width:100%; height:calc(100% - 120px);">
              <embed :src="'https://storage.googleapis.com/kokoro-294123.appspot.com/' + invoiceView.invoice.description" style="width: 100%; height: 100%; margin:auto"/>
            </div>
            <div style="width: 100%; height: 60px; display: flex;">

              <div style="width: 40%; font-size: 15px; padding: 5px;" v-html="getMerchantEmailList(invoiceView.merchantId)">

              </div>
              <div style="width: 40%; line-height: 60px; padding: 10px 5px;">
                <input tyle="text" v-model="invoiceView.sendTo" class="form-control" placeholder="Additional recipient"/>
              </div>
              <div style="width: 20%; padding:10px 5px; text-align: left;">
                <button class="btn btn-primary" v-on:click="sendInvoice(invoiceView)">SEND INVOICE</button>
              </div>


            </div>
            <div style="width:calc(100% - 800px); height:100%; overflow-y: scroll; padding:20px; text-align: left; display: none;">
              <h5></h5>
              <h6>Order Number: {{invoiceView.id}}</h6>
              <h6>Invoice Number: {{invoiceView.invoice.title}}</h6>
              <br>
              <br>
              <h6>NET: £{{(invoiceView.totalPrice/100.0).toFixed(2)}}</h6>
              <h6>TAX: £{{(invoiceView.tax/100.0).toFixed(2)}}</h6>
              <h6>GROSS: £{{(invoiceView.finalDue/100.0).toFixed(2)}}</h6>

              <br>
              <br>
              <h6>Delivery Date: {{invoiceView.deliveryDate}}</h6>
              <br>
              <br>
              <button class="form-control btn btn-dark" v-on:click="regenerateInvoice(invoiceView.id)">REGENERATE INVOICE</button>
              <br>
              <br>
              <button class="form-control btn btn-primary" v-on:click="sendInvoice(invoiceView)">SEND INVOICE</button>

              <table style="width: 100%; margin-top:20px;">
                <tr>
                  <td style="vertical-align: top; vertical-align: top;">
                    <label class="form-control" style="border:none;">Email to:</label>
                  </td>
                  <td style="text-align: left; vertical-align: top;">
                    <div v-html="getMerchantEmailList(invoiceView.merchantId)"/>
                  </td>

                </tr>

                <tr>
                  <td style="vertical-align: top; vertical-align: top;">
                    <label class="form-control" style="border:none;">Additional Email:</label>
                  </td>
                  <td style="text-align: left; vertical-align: top;">
                    <input tyle="text" v-model="invoiceView.sendTo" class="form-control"/>
                  </td>
                </tr>
              </table>


            </div>
          </div>
        </div>
      </transition>
      <transition name="slideup">
        <div class="item-container" style="z-index: 3;" v-if="deliveryNoteView != false" v-on:click="deliveryNoteView = false">
          <div style="position: absolute; width: 100%; height: 100%; top:0; left:0; background-color: white;" v-on:click.stop="dummy">
            <div style="width: 100%; height: 60px; display: flex;">
              <div style="height: 60px; line-height: 60px; width: 80px; font-size: 40px; text-align: center;">
                <i class="fas fa-file-invoice"></i>
              </div>
              <div style="height: 60px;">
                <div style="height: 35px; line-height: 35px; font-size: 20px; padding-left: 20px; font-weight: bold;">
                  {{getMerchantName(deliveryNoteView.merchantId)}} #{{deliveryNoteView.id}} Delivery Date: {{deliveryNoteView.deliveryDate}}
                </div>
                <div style="height: 25px; padding-left: 20px; text-align: left; font-size: 16px; color: #666; font-weight: bold;">
                  NET: £{{(deliveryNoteView.totalPrice/100.0).toFixed(2)}} / VAT: £{{(deliveryNoteView.tax/100.0).toFixed(2)}} / GROSS: £{{(deliveryNoteView.finalDue/100.0).toFixed(2)}}
                </div>
              </div>

              <div style="margin-left: auto;">


                <div style="width: 60px; height: 60px; line-height: 60px; font-size: 30px; margin-right: 30px;" v-on:click="deliveryNoteView = false">
                  <i class="fas fa-times" style="color:black;"></i>
                </div>
              </div>
            </div>
            <div style="width:100%; height:calc(100% - 60px);">
              <embed :src="'https://storage.googleapis.com/kokoro-294123.appspot.com/' + deliveryNoteView.deliveryNotes[deliveryNoteView.deliveryNotes.length-1]" style="width: 100%; height: 100%; margin:auto"/>
            </div>
            <div style="width:calc(100% - 800px); height:100%; overflow-y: scroll; padding:20px; text-align: left;">

            </div>
          </div>
        </div>
      </transition>
      <transition name="slideup">
        <div class="item-container" v-if="creditForm != false" v-on:click="creditForm = false;">
          <div style="position: absolute; top:50%; left: 50%; background: white; transform: translate(-50%, -50%); background: white; padding: 30px;" @click.stop="dummy">
            <div class="container">
              <div class="row">
                <div class="col-12" style="line-height: 50px; font-size: 20px; font-weight: bold;">
                  Credit Form
                </div>
                <div class="col-12" style="line-height: 40px; font-size: 18px; font-weight: bold;">
                  Order #{{creditForm.item.parentId}} {{getMerchantName(creditForm.item.merchantId)}} Date: {{creditForm.date}}
                </div>
                <div class="col-12" style="line-height: 30px; font-size: 15px; font-weight: bold;">
                  Item to return: {{creditForm.item.title}} x {{creditForm.item.amount}}
                </div>
              </div>
              <div class="row" style="margin-top: 20px;">
                <div class="col-6">
                  Quantity to return:
                </div>
                <div class="col-6">
                  <select v-model="creditForm.quantity" class="form-control">
                    <option value="0">Select</option>
                    <option v-for="q in creditForm.item.amount" :key="'return-quantity-selector-' + q" :value="q">{{q}}</option>
                  </select>
                </div>
              </div>
              <div class="row" style="margin-top: 20px;">
                <div class="col-6">Return type</div>
                <div class="col-6">
                  <select class="form-control" v-model="creditForm.stockType">
                    <option value="">Select</option>
                    <option value="return">Stock Return (add stock back)</option>
                    <option value="disposal">Disposal</option>
                    <option value="partial_refund">Partial Refund</option>
                  </select>
                </div>
              </div>
              <div class="row" style="margin-top: 50px;">
                <div class="col-6">
                  <div class="kh-btn kh-btn-smaller" @click="creditForm = false">Close</div>
                </div>
                <div class="col-6">
                  <div class="kh-btn kh-btn-smaller kh-6" @click="submitCreditForm">Submit</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </transition>

      <transition name="slideup">
        <div class="product-order-list-container" style="position: relative;" v-if="productOrderItems != false" @click="productOrderItems = false">
          <div class="product-order-list-inner-wrapper" @click.stop="dummy">

            <div class="product-order-list" style="width: 100%; height:calc(100% - 50px); overflow-y: auto;">

              <table class="table">
                <tr class="sticky-header-row">
<!--                  <th>#</th>-->
                  <th class="text-left">Product <input style="width: 300px;" v-model="productOrderItemFilter" placeholder="Search..."/> <span v-on:click="productOrderItemFilter = ''">Clear</span></th>
                  <th>Total Stock</th>
                  <th>Total Picked</th>
                  <th>Available Quantity</th>
                  <th>Total Quantity</th>
                  <th class="text-left">Shop</th>
                  <th>Quantity</th>
                  <th>Picked</th>
                  <th>Confirmed</th>
                  <th></th>
                </tr>

                <template v-for="(cat, ci) in productOrderItems">
                  <tbody v-for="(product, pi) in cat.products" style="border-top: 30px solid #dadada;" v-if="productOrderItemFilter == null || productOrderItemFilter.length == 0 || product.title.toLowerCase().includes(productOrderItemFilter.toLowerCase())">
                  <tr v-for="(order, oi) in product.orders">
<!--                    <td>{{order.id}}</td>-->
                    <td class="text-left"><span v-if=" oi == 0" style="font-size: 15px; font-weight: bold;">{{product.title}}</span></td>
                    <td><span v-if=" oi == 0">{{product.inventoryQuantity}}</span></td>
                    <td><span v-if=" oi == 0">{{product.midStockQuantity}}</span></td>
                    <td><span v-if=" oi == 0">{{product.inventoryQuantity - product.midStockQuantity}}</span></td>
                    <td><div v-if=" oi == 0" ><strong>{{product.orderAmount}}</strong></div></td>
                    <td class="text-left">{{getMerchantName(order.merchantId)}}</td>
                    <td><strong>{{order.orderedAmount}}<span v-if="order.orderedAmount !== order.amount"> <i class="fas fa-arrow-right"></i> {{order.amount}}</span></strong></td>
                    <td :class="{'no-picked': order.state >= 0 && order.state < 18 && order.midStockQuantity === 0, 'full-picked': order.state >= 0 && order.state < 18 && order.orderedAmount === order.midStockQuantity, 'less-picked': order.state >= 0 && order.state < 18 && order.orderedAmount > 0 && order.orderedAmount < order.midStockQuantity}"><strong v-if="order.state >= 0 && order.state < 18" style="font-size: 20px; font-weight: bold;">{{order.midStockQuantity}}</strong></td>
                    <td><div v-if="order.state >= 18" class="kh-4" style="font-size: 20px; font-weight: bold;">{{order.confirmedAmount}}</div></td>
                    <td :class="{'kh-9': order.state < 0}">{{order.stateText}}</td>
                  </tr>
                  </tbody>
                </template>
              </table>

            </div>
            <div class="container" style="padding:5px;">
<!--              <div class="floating-button" style="bottom:20px;right:20px; background-color: red; " v-on:click="closeProductOrderItems">-->
<!--                <span><i class="fas fa-times" style="color: white;"></i></span>-->
<!--              </div>-->
              <div class="row">
                <div class="col-12 text-right">
                  <button class="btn btn-dark" v-on:click="productOrderItems = false"><i class="fas fa-times" style="color:white;"></i> CLOSE</button>
                </div>
              </div>
<!--              <div class="floating-button" style="bottom:20px;right:100px; background-color: black;">-->
<!--                <span><i class="fas fa-print" style="color: white;"></i></span>-->
<!--              </div>-->
            </div>

          </div>

        </div>
      </transition>
    </div>
    <div class="manual-button" style="bottom: 20px; right: 40px; background: #000;" v-on:click="openManual">
      <i class="fas fa-question-circle"></i>
    </div>
  </div>
</template>

<script>
  import EventBus from "../api/event-bus";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import {
    queryOrders,
    getOrderStateList,
    getOrder,
    getInvoice,
    getProductOrderList,
    confirmOrderItem,
    confirmOrder,
    invoiceOrder,
    updateOrder,
    getDeliveryNote,
    completeOrder,
    addMemo,
    cancelOrderItem,
    cancelOrder,
    assignDriver,
    refreshOrder,
    deleteMemo,
    changeItemAmount,
    uncompleteOrder,
    sendInvoiceOrder,
    deleteOrder,
    updateMethod,
    searchOrder,
    changeOrderDate,
    updateOrderItem,
    changeOrder,
    setOrderDriver,
    invoiceOrderRegenerate,
    getOrderReport,
    getOrderListExcel
  } from "../api/order";
  import {getCategories, searchProducts} from "../api/product";
    import {getMerchants} from "../api/merchant";
  import {
    getShiftList,
    millisToDate,
    millisToReadable,
    setLastPage,
    showDialog,
    timeToLocaleDate,
    timeToLocaleDateShort, timeToLocaleDateYear
  } from "../api/utils";
  import {getDriverList, getUserByToken} from "../api/user";
  import {createCreditOrder} from "../api/creditOrder";
  import FileDownload from "js-file-download";
  const Stomp = require('stompjs');
    export default {
        name: "Orders",
      data() {
          return {
            orders:[],
            merchants:[],
            selectedMerchantId:0,
            selectedState:0,
            stateList:getOrderStateList(),
            currentOrder:false,
            merchantType:'all',
            productOrderItems: false,
            productOrderItemFilter:'',
            dateFrom:'',
            dateTo:'',
            itemDate:'',
            selectedDate:'',
            selectedDateFrom:'',
            selectedDateTo:'',
            searchInvoice:'',
            user: false,
            searchWord:'',
            candidates:[],
            newOrderMerchantId:0,
            newOrderDeliveryDate:'',
            drivers:[],
            newNote: false,
            changeItem: false,
            invoiceView: false,
            deliveryNoteView: false,

            sortList: {
              invoiceNumber:false,
              shopName:false,
              deliveryDate:false,
              deliveredDate:false,
              orderedDate:false,
              state:false,
              driver:false,
            },
            categories:[],
            superAdmin:false,

            connection:null,
            stompClient:null,
            shiftList:getShiftList(),
            disconnectSocket: false,
            creditForm: false,
          }
      },
      components: {
        DatePicker,
      },
      created() {
        setLastPage(this.$route.path);
        this.$data.dateFrom = millisToDate(new Date().getTime(), '-');
        this.$data.dateTo = millisToDate(new Date().getTime(), '-');
        if(localStorage.getItem("order-date-from") !== null) {
          this.$data.selectedDateFrom = localStorage.getItem("order-date-from");
        } else {
          this.$data.selectedDateFrom = millisToDate(new Date().getTime(), '-');
        }
        if(localStorage.getItem("order-date-to") !== null) {
          this.$data.selectedDateTo = localStorage.getItem("order-date-to");
        } else {
          this.$data.selectedDateTo = millisToDate(new Date().getTime(), '-');
        }
        this.$data.selectedDate = millisToDate(new Date().getTime(), '-');


        this.$data.newOrderDeliveryDate = millisToDate(new Date().getTime(), '-');

        this.$data.itemDate = millisToDate(new Date().getTime(), '-');

        // console.log("query");
        // console.log(this.$route.query);
        if(this.$route.query.hasOwnProperty("superAdmin")) {
          this.$data.superAdmin = true;
        }
      },
      mounted() {
        this.$data.disconnectSocket = false;
        this.getMyInfo();

      },
      beforeDestroy() {
        this.$data.disconnectSocket = true;
        this.disconnectWebsocket();
      },
      methods: {
        dateString:timeToLocaleDateShort,
        convertDeliveryDate: function(date) {

          if(date === null || date.length !== 10) {
            return date;
          }
          let d = new Date(date);
          return timeToLocaleDateYear(d.getTime());
        },
        getShiftText: function(val) {
          for(let i = 0 ; i < this.$data.shiftList.length ; i++) {
            if(val === this.$data.shiftList[i].value) {
              return this.$data.shiftList[i].title;
            }
          }
          return val;
        },
        convertDate: function(date) {
          // console.log("convert date " + date);
          if(date === null || date.length !== 10) {
            return date;
          }

          // let d = new Date(date);

          return timeToLocaleDateShort(date);
        },
        initialiseSearch: function() {
          this.$data.searchWord = '';
          this.$data.candidates = [];
        },
        getCategoryList: function() {
          let self = this;

          getCategories()
            .then(function(data){
              if(data.success == true) {
                self.$data.categories = data.item;
              }
            })
            .catch(function(err) {

            })
        },
        moveFocusOnCandidate: function(e, c) {
          const activeEle = e.target;
          // const activeEleIndex = Array.prototype.indexOf.call(activeEle.parentElement, activeEle);
          console.log(e);
          console.log(c);
          // console.log("index " + activeEleIndex);
          console.log(e.key);
          if(e.key == "ArrowDown" && activeEle.nextElementSibling != null) {
            console.log("move down");
            activeEle.nextElementSibling.focus();
          }

          if(e.key == "ArrowUp")
            if(activeEle.previousElementSibling != null) {
              console.log("move up");
              activeEle.previousElementSibling.focus();
            } else {
              document.getElementById("order-product-candidate-search-input").focus();
            }

          if(e.key == 'Enter') {

            if(activeEle.nextElementSibling != null) {
              activeEle.nextElementSibling.focus();
            } else if(activeEle.previousElementSibling != null) {
              activeEle.previousElementSibling.focus();
            }
            this.selectCandidate(c);
          }
        },
        search: function(e){

          if(e.key == 'ArrowDown') {
            console.log('ArrowDown');
            let firstCandidate = document.getElementById('order-product-candidate-0');
            if(firstCandidate != undefined && firstCandidate != null) {
              firstCandidate.focus();
            } else {
              console.log("cannot find ele");
            }
            return;
          }
          let self = this;
          console.log("Search " + this.$data.searchWord);
          if(this.$data.searchWord == null || this.$data.searchWord.length < 3) {
            this.$data.candidates = [];
            return;
          }


          searchProducts(this.$data.searchWord, this.$data.currentOrder.merchantId, 0)
            .then(function(data) {
              console.log("search result ");
              console.log(data);
              if(data.success == true) {
                self.$data.candidates =  data.item;
              } else {
                self.$data.candidates = [];
              }
            })
            .catch(function(err) {
              self.$data.candidates = [];
            })
          // return new Promise((resolve) => {
          //   if(input.length < 3) {
          //     resolve([]);
          //   }
          //   // self.searchProduct(encodeURI(input), resolve);
          //
          // })

        },
        selectCandidate: function(candidate) {
          // this.$data.candidates = [];


          this.$data.searchWord = '';
          let newOrder = {
            id:0,
            parentId:this.$data.currentOrder.id,
            title:candidate.title,
            originalPrice:candidate.sourcePrice,
            price:candidate.price,
            merchantPrice:candidate.price,
            orderedAmount:0,
            amount:1,
            taxRate:candidate.taxRate,
            discountRate:0,
            discountAmount:0,
            finalDue:0,
            state:0,
            tax: candidate.price * candidate.taxRate / 10000,
            totalPrice:candidate.price,
            merchantId:this.$data.currentOrder.merchantId,
            productId:candidate.id,
            product:JSON.parse(JSON.stringify(candidate)),
            useVariablePrice: candidate.useVariablePrice,
            variablePriceUnit: candidate.variablePriceUnit,
            categoryId: candidate.categoryId,
            categoryTitle:'',
          }
          for(let i = 0 ; i < this.$data.categories.length ; i++) {
            if(this.$data.categories[i].id === newOrder.categoryId) {
              newOrder.categoryTitle = this.$data.categories[i].title;
            }
          }
          this.$data.currentOrder.list.push(newOrder);

          for(let i = 0 ; i < this.$data.candidates.length ; i++) {
            if(this.$data.candidates[i].id == candidate.id) {
              this.$data.candidates.splice(i, 1);
              break;
            }
          }
          this.onOrderChanged();

        },
        getResultValue(result) {
          console.log("Get Result Value");
          console.log(result);
          return result.title
        },
        handleSubmit(result) {
          console.log("selected");
          console.log(result);
        },
        isAdmin: function() {
          if(this.$data.user != false && this.$data.user.type === 'ROLE_ADMIN') {
            return true;
          }
          return false;
        },
        isManager: function() {
          if(this.$data.user != false && (this.$data.user.type === 'ROLE_ADMIN' || this.$data.user.type === 'ROLE_MANAGER')) {
            return true;
          }
          return false;
        },

        getMyInfo: function() {
          let self = this;
          getUserByToken()
            .then(function(data) {
              self.$data.user = data;
              // console.log("user acquired");
              // console.log(self.$data.user);
              // if(self.$data.me.type === 'ROLE_ADMIN') {
              self.getMerchantList();
              self.getDriverList();
              self.getCategoryList();
              self.setWebsocketConnection();
              // }
            })
            .catch(function(err) {
              console.log(err);

            })
        },
        getDriverList: function() {
          let self = this;
          getDriverList()
          .then(function(data) {
            if(data.success == true) {
              self.$data.drivers = data.item;
            } else {
              showDialog("Driver가 없습니다.")
            }
          })
          .catch(function(err) {

          })
        },
        getDriverNameForSorting: function(id) {
          for(let i = 0 ; i < this.$data.drivers.length ; i++) {
            if(this.$data.drivers[i].id === id) {
              return this.$data.drivers[i].name;
            }
          }
          return '';
        },
        getDriverName: function(id) {
          for(let i = 0 ; i < this.$data.drivers.length ; i++) {
            if(this.$data.drivers[i].id == id) {
              return this.$data.drivers[i].name;
            }
          }
          return '(' + id + ')';
        },
        timeString:millisToReadable,
        getMerchantList: function() {
          let self = this;
          getMerchants()
          .then(function(data) {
            if(data.success == true) {
              let deactivatedList = [];
              for(let i = 0 ; i < data.item.length ; i++) {
                if(data.item[i].active === true) {
                  self.$data.merchants.push(data.item[i]);
                } else {
                  deactivatedList.push(data.item[i]);
                  // console.log(data.item[i].title + ' is ' + data.item[i].active);
                }
              }
              if(deactivatedList.length > 0) {
                for(let i = 0 ; i < deactivatedList.length ; i++) {
                  self.$data.merchants.push(deactivatedList[i]);
                }

              }
              // self.$data.merchants = data.item;
              // self.getDayOrderList();
            } else {

            }
          })
        },
        orderStateString: function(state) {
          for(let i = 0 ; i < this.$data.stateList.length ; i++) {
            if(this.$data.stateList[i].state === state) {
              return this.$data.stateList[i].title;
            }
          }
          return 'State:' + state;
        },
        searchOrderWithInvoice: function() {
          if(this.$data.searchInvoice == null || this.$data.searchInvoice.length < 3) {
            showDialog("인보이스로 검색시, 3글자 이상 입력해주세요");
            return;
          }
          let self = this;
          searchOrder(this.$data.searchInvoice)
          .then(function(data) {
            if(data.success == true) {
              self.$data.currentOrder = false;
              self.$data.orders = data.item;
            } else {
              showDialog(data.message);
            }

          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog("에러 발생 " + msg, "ERROR");
          })
        },

        getTodayOrderList: function(diff = 0) {
          let self = this;
          this.$data.currentOrder = false;
          this.$data.orders = [];
          let date = new Date();
          if(diff !== 0) {
            date.setDate(date.getDate() + diff)
          }
          console.log(date);
          let today = millisToDate(date.getTime(), '-');
          let query = "deliveryFrom=" + today + '&deliveryTo=' + today + "&listOnly=true";

          console.log(query);
          // if(this.$data.selectedMerchantId > 0) {
          //   query += "&merchantId=" + this.$data.selectedMerchantId;
          // }
          //this.$data.newOrderDeliveryDate = this.$data.selectedDate;
          console.log("get query " + query);
          queryOrders(query)
            .then(function(data) {
              if(data.success == true) {
                self.$data.orders = data.item;
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {

            });
        },
        getDayOrderList: function() {
          let self = this;
          this.$data.currentOrder = false;
          this.$data.orders = [];
          localStorage.setItem("order-date-from", this.$data.selectedDateFrom);
          localStorage.setItem("order-date-to", this.$data.selectedDateTo);
          let query = "deliveryFrom=" + this.$data.selectedDateFrom + '&deliveryTo=' + this.$data.selectedDateTo + "&listOnly=true";

          if(this.$data.selectedMerchantId > 0) {
            query += "&merchantId=" + this.$data.selectedMerchantId;
          }
          //this.$data.newOrderDeliveryDate = this.$data.selectedDate;
          console.log("get query " + query);
          queryOrders(query)
            .then(function(data) {
              if(data.success == true) {
                self.$data.orders = data.item;
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {

            })
        },
        getOrderList: function() {
          let self = this;
          this.$data.currentOrder = false;
          this.$data.orders = [];
          let query = "merchantId=" + this.$data.selectedMerchantId;

          if(this.$data.selectedState != -1000) {
            query += "&stateFrom=" + this.$data.stateList[this.$data.selectedState].state + "&stateTo=" + this.$data.stateList[this.$data.selectedState].state;
          }

          // This is for history items
          // so add time
          // if(this.$data.stateList[this.$data.selectedState].state == 100 || this.$data.stateList[this.$data.selectedState].state < 0) {
            var start = new Date(this.$data.dateFrom);
            start.setHours(0,0,0,0);
            var end = new Date(this.$data.dateTo);
            end.setHours(23,59,59,999);

            query += "&timeFrom=" + start.getTime() + "&timeTo=" + end.getTime();
          // }

          queryOrders(query)
          .then(function(data) {
            if(data.success == true) {
              self.$data.orders = data.item;
            } else {

            }
          })
          .catch(function(err) {

          })
        },
        getMerchantName: function(id) {
          if(this.$data.merchants.length == 0) {
            return 'Not Found';
          }

          for(let i = 0 ; i < this.$data.merchants.length ; i++) {
            if(this.$data.merchants[i].id == id) {
              return this.$data.merchants[i].title;
            }
          }
          return 'Unknown(' + id + ')';
        },
        getMerchantEmailList: function(id) {
          if(this.$data.merchants.length == 0) {
            return 'Not Found';
          }


          for(let i = 0 ; i < this.$data.merchants.length ; i++) {
            if(this.$data.merchants[i].id == id) {
              let text = "";
              if(this.$data.merchants[i].emails.length > 0) {
                text += '<strong>' + this.$data.merchants[i].emails.join(',') + '</strong>';
              }
              if(this.$data.merchants[i].ccEmails.length > 0) {
                text += '<br>';
                text += this.$data.merchants[i].ccEmails.join(',');
              }
              console.log(text);
              return text;
            }
          }
          return 'Unknown(' + id + ')';
        },


        closeProductOrderItems: function() {
          this.$data.productOrderItems = false;
        },
        showAllItemsToBeAccepted: function() {
          let merchantId = this.$data.selectedMerchantId;
          // let state = this.$data.stateList[this.$data.selectedState].state;
          let self = this;

          if(this.$data.itemDate === '') {
            showDialog("Please select date");
            return;
          }
          getProductOrderList(merchantId, this.$data.itemDate)
          .then(function(data) {
            if(data.success == true) {
              self.populateProductOrderList(data.item);
            } else {
              showDialog("", data.message);
            }
          })
          .catch(function(err) {
            console.log(err);
            if(err.response != undefined) {
              console.log(err.response);
            }
          })

        },
        populateProductOrderList: function(list) {


          for(let i = list.length -1 ; i >= 0 ; i--) {
            let catAvailable = false;
            if(list[i].products.length > 0) {

              for(let j = list[i].products -1 ; j >= 0 ; j--) {
                if(list[i].products[j].orders.length == 0) {
                  list[i].products.splice(j, 1);
                } else {
                  catAvailable = true;
                }
              }

            }

            if(catAvailable == false) {
              list.splice(i, 0);
            }

          }
          if(list.length > 0) {
            this.$data.productOrderItems = list;
          } else {
            showDialog("", "No Order Items");
          }


        },
        onItemClicked: function(id) {
          this.$data.currentOrder = false;
          this.openOrderItem(id);
        },
        dummy: function() {
          console.log("dummy clicked");
          this.$data.searchWord = '';
          if(this.$data.candidates.length  > 0) {
            this.$data.candidates = [];
          }
        },
        refreshItem: function(id) {
          let self = this;
          this.initialiseSearch();
          refreshOrder(id)
            .then(function(data) {
              if(data.success == true) {

                for(let i = 0 ; i < self.$data.orders.length ; i++) {
                  if(self.$data.orders[i].id == data.item.id) {
                    self.$data.orders.splice(i, 1, data.item);
                    break;
                  }
                }
                for(let i = 0 ; i < data.item.list.length ; i++) {
                  if(data.item.list[i].useVariablePrice == true) {
                    data.item.list[i].variablePricePerUnit = data.item.list[i].variablePricePerUnit / 100.0;
                    data.item.list[i].variablePriceAmount = Math.round(parseFloat(data.item.list[i].variablePriceAmountFloat) * 100);
                  }
                  data.item.list[i].discountAmount = data.item.list[i].discountAmount / 100.0;
                }

                console.log("before");
                for(let i = 0 ; i < data.item.list.length ; i++) {
                  console.log(data.item.list[i].title);
                }
                data.item.list.sort(function(a, b) {
                  let titleA = a.title;
                  let titleB = b.title;
                  console.log("compare " + titleA + " vs " + titleB);
                  if(titleA.includes('] ')) {
                    titleA = titleA.split('] ')[1];
                  }
                  if(titleB.includes('] ')) {
                    titleB = titleB.split('] ')[1];
                  }

                  titleA = titleA.trim();
                  titleB = titleB.trim();

                  return titleA.localeCompare(titleB);
                })
                data.item.list.sort(function(a, b) {
                  return a.categoryId - b.categoryId;
                })
                self.$data.currentOrder = data.item;

              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
                let msg = err;
                if(err.response !== undefined) {
                  msg += ' (' + err.response + ')';
                }
                showDialog(msg, "ERROR");
            })
        },
        closeCurrentOrder: function(close = false) {
          this.initialiseSearch();
          if(close == true) {
            this.$data.currentOrder = false;
          }
        },
        openOrderItem: function(id, removeIfStateIsDifferent = false) {
          let self = this;
          // this.initialiseSearch();
          this.$data.currentOrder = false;
          getOrder(id)
          .then(function(data) {
            if(data.success == true) {

              // console.log("order open");
              // console.log(data.item);
              for(let i = 0 ; i < self.$data.orders.length ; i++) {
                if(self.$data.orders[i].id == data.item.id) {
                  self.$data.orders.splice(i, 1, data.item);
                  break;
                }
              }
              // console.log("2: " +data.item.state);

              let totalWeight = 0;
              for(let i = 0 ; i < data.item.list.length ; i++) {
                // if(data.item.list[i].useVariablePrice == true) {
                //   data.item.list[i].variablePricePerUnit = data.item.list[i].variablePricePerUnit / 100.0;
                  // data.item.list[i].variablePriceAmount = data.item.list[i].variablePriceAmount / 100.0;
                // }
                if(data.item.list[i].state >= 0 && data.item.list[i].product != null) {
                  data.item.list[i].weight = data.item.list[i].product.weight;
                  data.item.list[i].totalWeight = data.item.list[i].product.weight * data.item.list[i].amount;
                  totalWeight += data.item.list[i].totalWeight;
                }
                // data.item.list[i].discountAmount = data.item.list[i].discountAmount / 100.0;
              }
              data.item.totalWeight = totalWeight;
              // console.log("3: " +data.item.state);
              // console.log("before");
              for(let i = 0 ; i < data.item.list.length ; i++) {
                if(data.item.list[i].title === null) {
                  data.item.list[i].title = 'Unknown'
                  console.log(data.item.list[i].title + " product id = " + data.item.list[i].productId);
                }

              }
              data.item.list.sort(function(a, b) {
                let titleA = a.title;
                let titleB = b.title;

                if(titleA.includes('] ')) {
                  titleA = titleA.split('] ')[1];
                }
                if(titleB.includes('] ')) {
                  titleB = titleB.split('] ')[1];
                }

                titleA = titleA.trim();
                titleB = titleB.trim();
                // if(titleA < titleB) {
                //   return 1;
                // } else if(titleA > titleB) {
                //   return -1;
                // }
                // return 0;
                return titleA.localeCompare(titleB);
                // return a.productId - b.productId;
              })
              // console.log("after");
              // for(let i = 0 ; i < data.item.list.length ; i++) {
              //   console.log(data.item.list[i].title);
              // }
              data.item.list.sort(function(a, b) {
                return a.categoryId - b.categoryId;
              })
              self.$data.currentOrder = data.item;
              // console.log("4: " +data.item.state);
              // console.log("5: " +self.$data.currentOrder.state);

            } else {

            }
          })
          .catch(function(err) {
              console.log(err);

              if(err.response !== undefined) {
                console.log(err.response);

              }
          })
        },

        deleteOrder: function(order) {
          let self = this;
          this.$modal.show('dialog', {
            // title: '',
            text: 'Are you sure to delete this order ' + order.id + ' ?',
            buttons: [
              {
                title: 'No',
                handler: () => {
                  self.$modal.hide('dialog');

                }
              },
              {
                title: 'Yes DELETE',
                handler: () => {
                  self.$modal.hide('dialog');
                  self.deleteOrderConfirmed(order.id);
                }
              },

            ]

          });
        },
        deleteOrderConfirmed: function(id) {
          let self = this;
          deleteOrder(id)
            .then(function(data) {
              if(data.success == true) {
                for(let i = 0 ; i < self.$data.orders.length ; i++) {
                  if(self.$data.orders[i].id == data.item.id) {

                    self.$data.orders.splice(i, 1);
                    break;
                  }
                }
                self.$data.currentOrder = false;
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              console.log("Delete order error " + err);
              let msg = err;
              if(err.response != undefined) {
                console.log(err.response);
                msg = ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");

            })
        },
        cancelOrder: function(order) {
          let self = this;
          this.$modal.show('dialog', {
            // title: '',
            text: 'Cancel this order?',
            buttons: [
              {
                title: 'No',
                handler: () => {
                  self.$modal.hide('dialog');

                }
              },
              {
                title: 'Cancel',
                handler: () => {
                  self.$modal.hide('dialog');
                  self.cancelOrderConfirmed(order.id);
                }
              },

            ]

          });
        },
        cancelOrderConfirmed: function(id) {
          let self = this;
          cancelOrder(id)
            .then(function(data) {
              if(data.success == true) {
                for(let i = 0 ; i < self.$data.orders.length ; i++) {
                  if(self.$data.orders[i].id == data.item.id) {

                    self.$data.orders.splice(i, 1, data.item);
                    break;
                  }
                }
                self.openOrderItem(id);
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              console.log("Confirm order item error " + err);
              if(err.response != undefined) {
                console.log(err.response);
              }
            })
        },
        cancelOrderItem: function(item) {
          let self = this;
          this.$modal.show('dialog', {
            //title: '로그아웃',
            text: 'Cancel ' + item.description + ' x' + item.amount + '?',
            buttons: [
              {
                title: 'No',
                handler: () => {
                  self.$modal.hide('dialog');

                }
              },
              {
                title: 'Yes Cancel',
                handler: () => {
                  self.$modal.hide('dialog');
                  self.cancelOrderItemConfirmed(item.id);
                }
              },

            ]

          });
        },
        cancelOrderItemConfirmed: function(id) {
          if(this.isManager() == false) {
            showDialog("Not Authorissed");
            console.log("Not admin manager");
            return;
          }
          let self = this;
          cancelOrderItem(id)
            .then(function(data) {
              if(data.success == true) {
                for(let i = 0 ; i < self.$data.currentOrder.list.length ; i++) {
                  if(self.$data.currentOrder.list[i].id == data.item.id) {
                    self.$data.currentOrder.list.splice(i, 1, data.item);
                    break;
                  }
                }

                self.onOrderChanged();
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              console.log("Confirm order item error " + err);
              if(err.response != undefined) {
                console.log(err.response);
              }
            })
        },
        confirmOrderItem: function(id, full=true) {
          if(this.isManager() == false) {
            console.log("Not admin manager");
            return;
          }
          let self = this;
          confirmOrderItem(id, full)
          .then(function(data) {
            if(data.success == true) {
              for(let i = 0 ; i < self.$data.currentOrder.list.length ; i++) {
                if(self.$data.currentOrder.list[i].id == data.item.id) {
                  self.$data.currentOrder.list.splice(i, 1, data.item);
                }
              }

            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            console.log("Confirm order item error " + err);
            if(err.response != undefined) {
              console.log(err.response);
            }
          })
        },
        askRemoveNote: function(note) {
          let self = this;
          this.$modal.show('dialog', {
            //title: '로그아웃',
            text: 'Delete this memo? "' + note.description + '"',
            buttons: [
              {
                title: 'No',
                handler: () => {
                  self.$modal.hide('dialog');

                }
              },
              {
                title: 'Yes Delete',
                handler: () => {
                  self.$modal.hide('dialog');
                  self.removeNoteConfirmed(note);
                }
              },

            ]

          });
        },
        removeNoteConfirmed: function(note) {
          let self = this;
          deleteMemo(note.id)
          .then(function(data) {
            if(data.success) {
              if(self.$data.currentOrder != false) {
                if(self.$data.currentOrder.notes.length > 0) {
                  for(let i = 0 ; i < self.$data.currentOrder.notes.length ; i++) {
                    if(self.$data.currentOrder.notes[i].id == data.item.id) {
                      self.$data.currentOrder.notes.splice(i, 1);
                      return;
                    }
                  }


                }

                if(self.$data.currentOrder.list.length > 0) {
                  for(let i = 0 ; i < self.$data.currentOrder.list.length ; i++) {
                    if(self.$data.currentOrder.list[i].notes.length > 0) {
                      for(let j = 0 ; j < self.$data.currentOrder.list[i].notes.length ; j++) {
                        if(self.$data.currentOrder.list[i].notes[j].id == data.item.id) {
                          self.$data.currentOrder.list[i].notes.splice(j, 1);
                          return;
                        }
                      }
                    }
                  }
                }

              }
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {

          })
        },
        showItemAmountChange: function(item) {
          if(this.isManager() == false) {
            return;
          }
          this.$data.changeItem = JSON.parse(JSON.stringify(item));
        },
        closeItemAmountChange: function() {
          this.$data.changeItem = false;
        },
        onItemAmountChanged: function(diff) {
          this.$data.changeItem.amount += diff;
          if(this.$data.changeItem.amount < 0) {
            this.$data.changeItem.amount = 0;
          }
        },
        submitItemAmountChange: function() {
          let self = this;
          let item = JSON.parse(JSON.stringify(this.$data.changeItem));

          item.variablePriceAmount = Math.round(parseFloat(item.variablePriceAmountFloat) * 100);
          changeItemAmount(item)
          .then(function(data) {
            self.closeItemAmountChange();
            if(data.success) {
              self.refreshCurrentOrder();
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            self.closeItemAmountChange();
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");

          })
        },
        onItemNoteAdded: function(index) {
          if(this.$data.currentOrder.list[index].note !== undefined && this.$data.currentOrder.list[index].note !== null && this.$data.currentOrder.list[index].note.length > 0) {
            this.$data.newNote = {
              id:0,
              orderId:this.$data.currentOrder.list[index].id,
              description:this.$data.currentOrder.list[index].note,
              toAll:false,
              toShop:false,
              toDriver:false,
            };

            this.$data.currentOrder.list[index].note = '';
          }
        },
        cancelNewNote: function() {
          this.$data.newNote = false;
        },
        onNoteConfirmed: function() {
          let newNote = JSON.parse(JSON.stringify(this.$data.newNote));
          let self = this;
          this.$data.newNote = false;
          addMemo(newNote)
          .then(function(data){
            if(data.success == true) {
              if(self.$data.currentOrder != false) {
                if(self.$data.currentOrder.id == data.item.orderId) {
                  self.$data.currentOrder.notes.push(data.item);
                  return;
                }

                for(let i = 0 ; i < self.$data.currentOrder.list.length ; i++) {
                  if(self.$data.currentOrder.list[i].id == data.item.orderId) {
                    self.$data.currentOrder.list[i].notes.push(data.item);
                    return;
                  }
                }
              }
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err){

          })
        },
        newNoteAdded: function() {
          console.log("newNoteAdded")
          if(this.$data.currentOrder.note !== undefined && this.$data.currentOrder.note.length > 0) {
            this.$data.newNote = {
              id:0,
              orderId:this.$data.currentOrder.id,
              description:this.$data.currentOrder.note,
              toAll:false,
              toShop:false,
              toDriver:false,
            };
            this.$data.currentOrder.note = '';
          }
        },
        collectedNow: function() {
          if(this.$data.currentOrder == false) {
            return;
          }
          if(this.$data.currentOrder.deliveryMethod !== 'collection') {
            showDialog("Cannot not set as current method is " + this.$data.currentOrder.deliveryMethod +". Please change method to collection first");
            return;
          }
          this.$data.currentOrder.driverId = 0;
          this.$data.currentOrder.delivered = true;
          this.$data.currentOrder.deliveredTime = new Date().getTime();


        },
        onCollectionUpdate: function() {
          if(this.$data.currentOrder == false) {
            return;
          }

          if(this.$data.currentOrder.deliveryMethod === 'collection') {
            this.$data.currentOrder.driverId = 0;

          }
          let self = this;
          updateMethod(this.$data.currentOrder)
            .then(function(data) {
              if(data.success == true) {

              } else {
                showDialog(data.message);
              }
              self.openOrderItem(data.item.id);
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
              self.openOrderItem(data.item.id);
            })
        },
        onDriverChange: function() {
          if(this.$data.currentOrder == false) {
            return;
          }
          let self = this;
          assignDriver(this.$data.currentOrder.id, this.$data.currentOrder.driverId)
          .then(function(data) {
            if(data.success == true) {

            } else {
              showDialog(data.message);
            }
            self.openOrderItem(data.item.id);
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
            self.openOrderItem(data.item.id);
          })
        },
        onPriceChanged: function(index) {
          console.log("new price float " + this.$data.currentOrder.list[index].priceFloat);
          this.$data.currentOrder.list[index].price = parseInt(parseFloat(this.$data.currentOrder.list[index].priceFloat)*100);
          this.$data.currentOrder.list[index].merchantPrice = this.$data.currentOrder.list[index].price;
          console.log("new price " + this.$data.currentOrder.list[index].price);
          this.onOrderChanged();
        },
        onOrderAmountChanged: function(item) {
          let self = this;
          updateOrderItem(item)
            .then(function(data) {
              if(data.success === true) {
                if(data.item.parentId === self.$data.currentOrder.id) {
                  for(let i = 0 ; i < self.$data.currentOrder.list.length ; i++) {
                    self.$data.currentOrder.list.splice(i, 1, data.item);
                    return;
                  }
                }
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })
        },
        changeOrderDeliveryData: function(order) {
          let query = 'deliveryDate=' + order.deliveryDate;

          let self = this;
          changeOrder(order.id, query)
            .then(function(data) {
              if(data.success === true) {
                for(let i = 0 ; i < self.$data.orders.length ; i++) {
                  if(self.$data.orders[i].id === data.item.id) {
                    self.$data.orders.splice(i, 1, data.item);
                    break;
                  }
                }

                if(self.$data.currentOrder.id === data.item.id) {
                  self.$data.currentOrder.updatedTimestamp = data.item.updatedTimestamp;
                  self.$data.currentOrder.deliveryDate = data.item.deliveryDate;
                }
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })
        },
        changeOrderDeliveryShift: function(order) {
          let query = 'deliveryShift=' + order.deliveryShift;

          let self = this;
          changeOrder(order.id, query)
            .then(function(data) {
              if(data.success === true) {
                for(let i = 0 ; i < self.$data.orders.length ; i++) {
                  if(self.$data.orders[i].id === data.item.id) {
                    self.$data.orders.splice(i, 1, data.item);
                    break;
                  }
                }

                if(self.$data.currentOrder.id === data.item.id) {
                  self.$data.currentOrder.updatedTimestamp = data.item.updatedTimestamp;
                  self.$data.currentOrder.deliveryShift = data.item.deliveryShift;
                }
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })
        },
        changeOrderDriver: function(order) {
          let query = 'driverId=' + order.driverId;

          let self = this;
          changeOrder(order.id, query)
            .then(function(data) {
              if(data.success === true) {
                for(let i = 0 ; i < self.$data.orders.length ; i++) {
                  if(self.$data.orders[i].id === data.item.id) {
                    self.$data.orders.splice(i, 1, data.item);
                    break;
                  }
                }

                if(self.$data.currentOrder.id === data.item.id) {
                  self.$data.currentOrder.updatedTimestamp = data.item.updatedTimestamp;
                  self.$data.currentOrder.driverId = data.item.driverId;
                }
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })
        },
        updateOrderPriceOnItemChanged: function() {
          let totalWeight = 0;
          this.$data.currentOrder.discountAmount = 0;
          this.$data.currentOrder.totalPrice = 0;
          this.$data.currentOrder.tax = 0;
          this.$data.currentOrder.finalDue = 0;
          for(let index = 0 ; index < this.$data.currentOrder.list.length ; index++) {
            if(this.$data.currentOrder.list[i].state < 0) {
              continue;
            }
            totalWeight += this.$data.currentOrder.list[index].totalWeight;
            this.$data.currentOrder.discountAmount += this.$data.currentOrder.list[i].discountAmount;
            this.$data.currentOrder.totalPrice += this.$data.currentOrder.list[i].totalPrice
            this.$data.currentOrder.tax += this.$data.currentOrder.list[i].tax;
          }
          this.$data.currentOrder.finalDue = this.$data.currentOrder.totalPrice + this.$data.currentOrder.tax;
        },
        onDiscountApplied: function() {

        },
        onOrderChanged: function() {
          let totalWeight = 0;
          for(let index = 0 ; index < this.$data.currentOrder.list.length ; index++) {
            if(this.$data.currentOrder.list[index].state < 0) {
              continue;
            }
            // console.log("onOrderChanged " + index);
            // console.log(this.$data.currentOrder.list[index]);
            if (this.$data.currentOrder.list[index].discountRate !== 0) {
            //   this.$data.currentOrder.list[index].discountAmount = 0;
            // } else {
              this.$data.currentOrder.list[index].discountAmount = (this.$data.currentOrder.list[index].merchantPrice * this.$data.currentOrder.list[index].discountRate / 10000)/100.0;
            } else if(this.$data.currentOrder.list[index].discountRate === 0) {
              this.$data.currentOrder.list[index].discountAmount = 0;
            }



            if(this.$data.currentOrder.list[index].useVariablePrice === true) {
              this.$data.currentOrder.list[index].variablePriceAmount = Math.round(parseFloat(this.$data.currentOrder.list[index].variablePriceAmountFloat)*100);
              if(this.$data.currentOrder.list[index].variablePriceAmount >= 10000) {
                this.$data.currentOrder.list[index].variablePriceAmount = 0;
                this.$data.currentOrder.list[index].variablePriceAmountFloat = 0;
                showDialog("Weight cannot be greater than 100kg");
                return;
              }
              if(this.$data.currentOrder.list[index].variablePricePerUnitFloat !== null && this.$data.currentOrder.list[index].variablePricePerUnitFloat !== '') {
                this.$data.currentOrder.list[index].variablePricePerUnit = Math.round(parseFloat(this.$data.currentOrder.list[index].variablePricePerUnitFloat) * 100);
              } else {
                this.$data.currentOrder.list[index].variablePricePerUnit = 0;
              }
              if(this.$data.currentOrder.list[index].variablePricePerUnit > 0) {
                this.$data.currentOrder.list[index].totalPrice = this.$data.currentOrder.list[index].variablePricePerUnit * this.$data.currentOrder.list[index].variablePriceAmount / 100;
              } else {
                this.$data.currentOrder.list[index].totalPrice = this.$data.currentOrder.list[index].price * this.$data.currentOrder.list[index].variablePriceAmount / 100;
              }
            } else {
              let dc = parseInt(parseFloat(this.$data.currentOrder.list[index].discountAmount).toFixed(2).replace(".", ""));
              this.$data.currentOrder.list[index].price = this.$data.currentOrder.list[index].merchantPrice - dc;
              this.$data.currentOrder.list[index].totalPrice = this.$data.currentOrder.list[index].price * this.$data.currentOrder.list[index].amount;
            }



            this.$data.currentOrder.list[index].tax = this.$data.currentOrder.list[index].totalPrice * this.$data.currentOrder.list[index].taxRate / 10000
            // console.log("DC " + this.$data.currentOrder.list[index].discountRate + " amount " + this.$data.currentOrder.list[index].discountAmount);

            if(this.$data.currentOrder.list[index].product != null) {
              this.$data.currentOrder.list[index].weight = this.$data.currentOrder.list[index].product.weight;
              this.$data.currentOrder.list[index].totalWeight = this.$data.currentOrder.list[index].product.weight * this.$data.currentOrder.list[index].amount;
              totalWeight += this.$data.currentOrder.list[index].totalWeight;
            }
          }
          this.$data.currentOrder.totalWeight = totalWeight;
          this.$data.currentOrder.discountAmount = 0;
          this.$data.currentOrder.totalPrice = 0;
          this.$data.currentOrder.tax = 0;
          for(let i = 0; i < this.$data.currentOrder.list.length ; i++) {
            if(this.$data.currentOrder.list[i].state < 0) {
              continue;
            }
            let dc = parseInt(parseFloat(this.$data.currentOrder.list[i].discountAmount).toFixed(2).replace(".", ""));
            this.$data.currentOrder.discountAmount += dc*this.$data.currentOrder.list[i].amount;
            this.$data.currentOrder.totalPrice += this.$data.currentOrder.list[i].totalPrice
            this.$data.currentOrder.tax += this.$data.currentOrder.list[i].tax;
          }

          this.$data.currentOrder.finalDue = this.$data.currentOrder.totalPrice + this.$data.currentOrder.tax;

          let self = this;
          let item = JSON.parse(JSON.stringify(this.$data.currentOrder));
          for(let i = 0 ; i < item.list.length ; i++) {
            // if(item.list[i].useVariablePrice == true) {
              // item.list[i].variablePricePerUnit = item.list[i].variablePricePerUnit *100;
              // item.list[i].variablePriceAmount = item.list[i].variablePriceAmount *100;
            // }
            item.list[i].discountAmount = parseInt(parseFloat(item.list[i].discountAmount).toFixed(2).replace(".", ""));
            // console.log("before update");
            // console.log("DC rate " + item.list[i].discountRate + ' £' + item.list[i].discountAmount);
          }


          updateOrder(item)
          .then(function(data) {
            if(data.success == true) {
              for(let i = 0 ; i < self.$data.orders.length ; i++) {
                if(self.$data.orders[i].id == data.item.id) {
                  self.$data.orders.splice(i, 1, data.item);
                  break;
                }
              }


              self.openOrderItem(data.item.id);
            } else {
              showDialog(data.message, "OOPS");
            }
          })
          .catch(function(err) {

          })
        },
        itemDcRateChanged: function(index) {
          console.log("itemDecRateChange");
          if(this.$data.currentOrder.list[index].discountRate == 0) {
            this.$data.currentOrder.list[index].discountAmount = 0;
          } else {
            this.$data.currentOrder.list[index].discountAmount = this.$data.currentOrder.list[index].merchantPrice * this.$data.currentOrder.list[index].discountRate / 10000;
          }
          this.$data.currentOrder.list[index].price = this.$data.currentOrder.list[index].merchantPrice + this.$data.currentOrder.list[index].discountAmount;
          this.$data.currentOrder.list[index].totalPrice = this.$data.currentOrder.list[index].price * this.$data.currentOrder.list[index].amount;
          this.$data.currentOrder.list[index].tax = this.$data.currentOrder.list[index].totalPrice * this.$data.currentOrder.list[index].taxRate/10000
          console.log("DC " + this.$data.currentOrder.list[index].discountRate + " amount " + this.$data.currentOrder.list[index].discountAmount);

          this.$data.currentOrder.discountAmount = 0;
          this.$data.currentOrder.totalPrice = 0;
          this.$data.currentOrder.tax = 0;
          for(let i = 0; i < this.$data.currentOrder.list.length ; i++) {
            let dc = parseInt(parseFloat(this.$data.currentOrder.list[i].discountAmount).toFixed(2).replace(".", ""));
            this.$data.currentOrder.discountAmount += dc;
            this.$data.currentOrder.totalPrice += this.$data.currentOrder.list[i].totalPrice
            this.$data.currentOrder.tax += this.$data.currentOrder.list[i].tax;
          }

          this.$data.currentOrder.finalDue = this.$data.currentOrder.totalPrice + this.$data.currentOrder.tax;
        },
        onOrderMarginRateChanged: function() {
          this.$data.currentOrder.totalPrice = 0;
          for(let i = 0 ; i < this.$data.currentOrder.list.length ; i++) {
            this.$data.currentOrder.list[i].marginRate = this.$data.currentOrder.marginRate;
            this.$data.currentOrder.list[i].price = this.$data.currentOrder.list[i].originalPrice + (this.$data.currentOrder.list[i].marginRate/10000 * this.$data.currentOrder.list[i].originalPrice);
            this.$data.currentOrder.list[i].totalPrice = this.$data.currentOrder.list[i].price * this.$data.currentOrder.list[i].amount;
            this.$data.currentOrder.totalPrice += this.$data.currentOrder.list[i].totalPrice;
          }
        },
        changeOrderState: function(state) {
          if(this.isManager() == false) {
            return;
          }
          if(state <= this.$data.currentOrder.state) {
            return;
          }
          if(state == 20) {
            this.confirmOrder(this.$data.currentOrder.id);
            return;
          } else if(state == 30) {
            this.invoiceOrder(this.$data.currentOrder.id);
            return;
          } else if(state == 100) {
            this.completeOrder(this.$data.currentOrder.id);
          }
        },
        changeReportDate: function() {
          let newDate = document.getElementById("new-report-date").value;
          if(newDate === null || newDate === '') {
            showDialog("Select new report date to change");
            return;
          }

          let self = this;
          this.$modal.show('dialog', {
            //title: '로그아웃',
            text: '주문 #' + this.$data.currentOrder.id + " Report Date 를 " + newDate +"로 변경 하시겠습니까? 변경시, 주문, 아이템, 재고 출고 날짜도 변경이 됩니다. Accounting report에서 날짜순 정렬이 정확하지 않을 수 있습니다. ",
            buttons: [
              {
                title: '아니요',
                handler: () => {
                  self.$modal.hide('dialog');

                }
              },
              {
                title: '변경',
                handler: () => {
                  self.$modal.hide('dialog');
                  self.changeReportDateConfirmed(newDate);
                }
              },

            ]

          });

        },
        changeReportDateConfirmed: function(newDate) {
          let self = this;
          changeOrderDate(this.$data.currentOrder.id, newDate)
            .then(function(data) {
              if(data.success == true) {

              } else {
                showDialog(data.message, "Sorry Failed to update");
              }
              self.openOrderItem(self.$data.currentOrder.id, true);
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += " (" + err.response + ")";
              }
              showDialog(msg, "Error happened");
            })
        },
        uncompleteOrder: function(orderId) {
          let self = this;
          this.$modal.show('dialog', {
            //title: '로그아웃',
            text: '주문 #' + orderId + " 완료상태를 취소하시겠습니까?",
            buttons: [
              {
                title: '아니요',
                handler: () => {
                  self.$modal.hide('dialog');

                }
              },
              {
                title: '완료상태 취소',
                handler: () => {
                  self.$modal.hide('dialog');
                  self.uncompleteOrderConfirmed(orderId);
                }
              },

            ]

          });
        },
        uncompleteOrderConfirmed: function(orderId) {
          let self = this;
          uncompleteOrder(orderId)
            .then(function(data) {
              if(data.success == true) {

              } else {
                showDialog(data.message, "Sorry Failed to update");
              }
              self.openOrderItem(orderId, true);
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += " (" + err.response + ")";
              }
              showDialog(msg, "Error happened");
            })
        },
        completeOrder: function(orderId, sendInvoice) {
          //Verify
          if(this.$data.currentOrder.state < 20) {
            showDialog("Order state is not confirmed yet<br>Order can be completed after confirm or delivered", "Sorry");
            return;
          }
          // if(this.$data.currentOrder.delivered === false) {
          //   showDialog("Order is not delivered yet<br>Order can be completed after confirm or delivered", "Sorry");
          //   return;
          // }

          if(this.$data.currentOrder.state > 100) {
            showDialog("This order is already completed", "Sorry");
            return;
          }

          for(let i = 0 ; i < this.$data.currentOrder.list.length ; i++) {
            if(this.$data.currentOrder.list[i].state >= 0 && this.$data.currentOrder.list[i].state < 20) {
              showDialog(this.$data.currentOrder.list[i].title + " is not yet confirmed/cancelled/rejected yet", "State error");
              return;
            }
          }

          // for(let i = 0 ; i < this.$data.currentOrder.list.length ; i++) {
          //   this.$data.currentOrder.list[i].state = 100;
          // }
          // this.$data.currentOrder.state = 100;
          let self = this;
          completeOrder(this.$data.currentOrder.id, sendInvoice)
          .then(function(data) {
            if(data.success == true) {

            } else {
              showDialog(data.message, "Sorry Failed to update");
            }
            self.openOrderItem(self.$data.currentOrder.id, true);
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += " (" + err.response + ")";
            }
            showDialog(msg, "Error happened");
          })


        },
        invoiceOrder: function(orderId) {
          let self = this;
          invoiceOrder(orderId)
          .then(function(data) {
            if(data.success == true) {
              self.openOrderItem(orderId, true);
            } else {
              showDialog(data.message, "Failed");
            }
          })
          .catch(function(err) {
            console.log(err);
            if(err.response != undefined) {
              console.log(err.response);
            }
          })
        },
        sendInvoice: function(order) {
          console.log("Send order " + order.id + " to " + order.sendTo);
          sendInvoiceOrder(order.id, order.sendTo)
          .then(function(data) {
            if(data.success) {
              showDialog("Invoice Successfully Sent")
            } else {
              showDialog(data.message, "Failed");
            }
          })
          .catch(function(err){
            let msg = err;
            console.log(err);
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
              console.log(err.response);
            }
            showDialog(msg, "ERROR");
          })
        },
        regenerateInvoice: function(orderId) {
          let self = this;
          self.$data.invoiceView = false;
          invoiceOrderRegenerate(orderId)
            .then(function(data) {
              if(data.success == true) {
                self.$data.invoiceView = data.item;

                for(let i = 0 ; i < self.$data.orders.length ; i++) {
                  if(self.$data.orders[i].id == data.item.id) {
                    self.$data.orders.splice(i, 1, data.item);
                  }
                }
              } else {
                showDialog(data.message, "Failed");
              }
            })
            .catch(function(err) {
              console.log(err);
              if(err.response != undefined) {
                console.log(err.response);
              }
            })
        },
        deliveryNote: function(orderId, skipIfDelivered = true) {
          // const FileDownload = require('js-file-download');
          let self = this;
          getDeliveryNote(orderId, skipIfDelivered)
            .then(function(data) {
              if(data.success == true) {
                if(data.item.deliveryNotes.length > 0) {
                  // self.printPDF(data.item.deliveryNotes[data.item.deliveryNotes.length-1]);
                  self.deliveryNoteView = data.item;//.deliveryNotes[data.item.deliveryNotes.length-1];
                }
                self.refreshCurrentOrder();
              } else {
                showDialog(data.message);
              }
              // FileDownload(response.data, "Kokoro-Delivery-Note-" + orderId + ".pdf");
            })
            .catch(function(err) {
              let msg = err;
              console.log(err);
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
                console.log(err.response);
              }
              showDialog(msg, "ERROR");
            })

        },
        printPDF: function(url) {
          var printPage = window.open('https://storage.googleapis.com/kokoro-294123.appspot.com/' + url, '_blank');

          printPage.print();

        },
        onPostDeliveryNote: function() {

        },
        invoice: function(order) {


          let url = 'https://storage.googleapis.com/kokoro-294123.appspot.com/' + order.imageUrls[order.imageUrls.length -1];
          window.open(url, '_blank');
          // const FileDownload = require('js-file-download');
          // let self = this;
          // getInvoice(orderId)
          // .then(function(response) {
          //   FileDownload(response.data, "Kokoro-Invoice-" + orderId + ".pdf");
          // })
          // .catch(function(err) {
          //
          // })
        },
        confirmOrder: function(id) {
          // for(let i = 0 ; i < this.$data.currentOrder.list.length ; i++) {
          //   if(this.$data.currentOrder.list[i].state == 0) {
          //     showDialog("There are unconfirmed items.<br> All items must be either confirmed or rejected");
          //     return;
          //   }
          // }

          let self = this;
          confirmOrder(id)
          .then(function(data) {
            if(data.success == true) {
              for(let i = 0 ; i < self.$data.orders.length ; i++) {
                if(self.$data.orders[i].id == data.item.id) {
                  self.$data.orders.splice(i, 1, data.item);
                  break;
                }
              }
              for(let i = 0 ; i < data.item.list.length ; i++) {
                if(data.item.list[i].useVariablePrice == true) {
                  data.item.list[i].variablePricePerUnit = data.item.list[i].variablePricePerUnit / 100.0;
                  // data.item.list[i].variablePriceAmount = data.item.list[i].variablePriceAmount / 100.0;
                }
                data.item.list[i].discountAmount = data.item.list[i].discountAmount/100.0;
              }
              self.$data.currentOrder = data.item;
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, 'ERROR');
          })
        },
        saveOrder: function() {
          let self = this;
          if(self.$data.currentOrde == false) {
            return;
          }
          updateOrder(this.$data.currentOrder)
          .then(function(data) {
            if(data.success == true) {
              self.refreshCurrentOrder();
            }
          })
          .catch(function(err) {

          })
        },
        refreshCurrentOrder: function() {
          let self = this;
          if(self.$data.currentOrder == false) {
            return;
          }
          getOrder(self.$data.currentOrder.id)
            .then(function(data) {
              if(data.success == true) {
                for(let i = 0 ; i < data.item.list.length ; i++) {
                  if(data.item.list[i].useVariablePrice == true) {
                    data.item.list[i].variablePricePerUnit = data.item.list[i].variablePricePerUnit / 100.0;
                    // data.item.list[i].variablePriceAmount = data.item.list[i].variablePriceAmount / 100.0;
                  }
                }
                self.$data.currentOrder = data.item;
                for(let i = 0 ; i < self.$data.orders.length ; i++) {
                  if(self.$data.orders[i].id == data.item.id) {
                    self.$data.orders.splice(i, 1, data.item);
                    break;
                  }
                }
              } else {

              }
            })
            .catch(function(err) {

            })
        },
        createNewOrder: function() {

          if(this.$data.newOrderMerchantId <= 0) {
            showDialog("Please select Shop");
            return;
          }

          if(this.$data.newOrderDeliveryDate === '' || this.$data.newOrderDeliveryDate === '0000-00-00') {
            showDialog("Please select delivery date");
            return;
          }
          let newOrder = {
            id:0,
            merchantId:this.$data.newOrderMerchantId,
            deliveryDate:this.$data.newOrderDeliveryDate,
            delivered:false,

          }
          let self = this;
          updateOrder(newOrder)
          .then(function(data) {
            if(data.success == true) {
              self.$data.orders.push(data.item);
              self.openOrderItem(data.item.id);
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {

          })
        },
        openInvoiceView: function(id) {

          this.$data.invoiceView = false;
          let self = this;
          getOrder(id)
          .then(function(data) {
            if(data.success == true) {


              if(data.item.invoice == null) {
                showDialog("Invoice is not generated yet");
                return;
              }
              self.$data.invoiceView = data.item;

            } else {

              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ")";
            }
            console.log(err);
            showDialog(msg, "ERROR");
          })
        },
        closeInvoiceView: function() {
          this.$data.invoiceView = false;
        },
        openManual: function() {
          let url = "https://sites.google.com/boriumstudio.com/kokoro-erp-manual/%EC%A3%BC%EB%AC%B8%EA%B4%80%EB%A6%AC";
          window.open(url, '_blank');
        },
        onDriverChanged: function(order) {
          let self = this;
          setOrderDriver(order.id, order.driverId)
            .then(function(data) {
              if(data.success === true) {

              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response !== undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })
        },
        getHistory: function(title, message, query) {
          EventBus.$emit("getHistory", title, message, query);
        },
        getOrderTracking: function(id) {
          EventBus.$emit("getOrderItemTracking", id);
        },
        downloadOrderList: function() {
          if(this.$data.selectedDateFrom === null || this.$data.selectedDateTo === null) {
            return;
          }
          let query = "merchantId=0";
          query += "&deliveryFrom=" + this.$data.selectedDateFrom + "&deliveryTo=" + this.$data.selectedDateTo;
          let self = this;
          const FileDownload = require('js-file-download');
          getOrderListExcel(query)
            .then(function(response) {
              FileDownload(response.data, "Kokoro-Sales-" + self.$data.selectedDateFrom + "-" + self.$data.selectedDateTo + "-report.xlsx");
            })
            .catch(function(err) {
              console.log("report error " + err);
              if(err.response != undefined) {
                console.log(err.response);
              }
            })
        },
        showCreditForm: function(item) {
          this.$data.creditForm  = {
            item: item,
            date: this.$data.currentOrder.deliveryDate,
            quantity: 0,
            stockType:'',
          }
        },
        submitCreditForm: function() {
          if(this.$data.creditForm.quantity === 0) {
            showDialog("Please select quantity to return");
            return;
          }

          if(this.$data.creditForm.stockType === '') {
            showDialog("Please select stock type");
            return;
          }


          let self = this;
          createCreditOrder(this.$data.creditForm.item.id, this.$data.creditForm.quantity, this.$data.creditForm.stockType)
            .then(function(data) {
              if(data.success === true) {
                self.$data.creditForm = false;
                showDialog("Credit order generated successfully. ID is " + data.item.id, "Successful");
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response !== undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })

        },
        sortByInvoiceNumber: function() {
          this.$data.sortList.invoiceNumber = !this.$data.sortList.invoiceNumber;
          if(this.$data.orders.length  == 0) {
            return;
          }
          let self = this;
          this.$data.orders.sort(function(a, b){
            let ai = '';
            let bi = '';
            if(a.invoice != null) {
              ai = a.invoice.title;
            }
            if(b.invoice != null) {
              bi = b.invoice.title;
            }
            if(ai > bi) {
              return self.$data.sortList.invoiceNumber?1:-1;
            }
            return self.$data.sortList.invoiceNumber?-1:1;
          })
        },

        sortByShopName: function() {
          this.$data.sortList.shopName = !this.$data.sortList.shopName;
          if(this.$data.orders.length  == 0) {
            return;
          }
          let self = this;
          this.$data.orders.sort(function(a, b){
            let at = self.getMerchantName(a.merchantId);
            let bt = self.getMerchantName(b.merchantId);

            if(at > bt) {
              return self.$data.sortList.shopName?1:-1;
            }
            return self.$data.sortList.shopName?-1:1;
          })
        },
        sortByState: function() {
          this.$data.sortList.state = !this.$data.sortList.state;
          if(this.$data.orders.length  == 0) {
            return;
          }
          let self = this;
          this.$data.orders.sort(function(a, b){
            if(a.state > b.state) {
              return self.$data.sortList.state?1:-1;
            }
            return self.$data.sortList.state?-1:1;
          })
        },
        sortByDriver: function() {
          this.$data.sortList.driver = !this.$data.sortList.driver;
          if(this.$data.orders.length  == 0) {
            return;
          }
          let self = this;
          this.$data.orders.sort(function(a, b){
            if(self.getDriverNameForSorting(a.driverId) > self.getDriverNameForSorting(b.driverId)) {
              return self.$data.sortList.driver?1:-1;
            }
            return self.$data.sortList.driver?-1:1;
          })
        },
        sortByOrderedDate: function() {
          this.$data.sortList.orderedDate = !this.$data.sortList.orderedDate;
          if(this.$data.orders.length  == 0) {
            return;
          }
          let self = this;
          this.$data.orders.sort(function(a, b){
            if(a.createdTimestamp > b.createdTimestamp) {
              return self.$data.sortList.orderedDate?1:-1;
            }
            return self.$data.sortList.orderedDate?-1:1;
          })
        },
        sortByDeliveryDate: function() {
          this.$data.sortList.deliveryDate = !this.$data.sortList.deliveryDate;
          if(this.$data.orders.length  == 0) {
            return;
          }
          let self = this;
          this.$data.orders.sort(function(a, b){
            if(a.deliveryDate > b.deliveryDate) {
              return self.$data.sortList.deliveryDate?1:-1;
            }
            return self.$data.sortList.deliveryDate?-1:1;
          })
        },
        sortByDeliveredDate: function() {
          this.$data.sortList.deliveredDate = !this.$data.sortList.deliveredDate;
          if(this.$data.orders.length  == 0) {
            return;
          }
          let self = this;
          this.$data.orders.sort(function(a, b){
            if(a.deliveredDate > b.deliveredDate) {
              return self.$data.sortList.deliveredDate?1:-1;
            }
            return self.$data.sortList.deliveredDate?-1:1;
          })
        },
        getDayOfWeek: function(date) {
          let day = new Date(date).getDay();
          if(day === 0) {
            return 'Sunday';
          } else if(day === 1) {
            return 'Monday';
          } else if(day === 2) {
            return 'Tuesday';
          } else if(day === 3) {
            return 'Wednesday';
          } else if(day === 4) {
            return 'Thursday';
          } else if(day === 5) {
            return 'Friday';
          } else if(day === 6) {
            return 'Saturday';
          }
          return 'Unknown Day(' + day + ')';
        },
        handleMessageReceipt: function (messageOutput) {
          console.log("message received " + messageOutput);
        },
        handleNotificationReceived: function(message) {
          console.log("message received " + message);
          let msg = JSON.parse(message);
          if(msg.cmd === 'newOrder') {
            if(msg.message !== undefined && msg.message.length > 0) {
              showDialog(msg.message);
            }
          } else if(msg.cmd === 'stateChanged') {
            if(msg.message !== undefined && msg.message.length > 0) {

              if(msg.orderId !== undefined && msg.orderId > 0) {
                if(this.$data.currentOrder.id === msg.orderId) {
                  showDialog(msg.message);
                  this.openOrderItem(msg.orderId);
                }
              }
            }
          }
        },
        setWebsocketConnection: function() {
          console.log("Connect socket");
          if(this.$data.stompClient !== null && this.$data.stompClient.state === 'CONNECTED') {
            console.log("Websocket already connected so skip");
            return;
          }
          console.log("connect to " + process.env.ROOT_BASE + 'connect');
          let socket = new SockJS(process.env.ROOT_BASE + 'connect');
          // let socket = new SockJS('https://api.showmemenu.net/connect');
          console.log(socket);
          this.$data.stompClient = Stomp.over(socket);
          console.log("Connect socket 2");
          let self = this;
          console.log(this.$data.stompClient);
          if(this.$data.stompClient.state === 'CONNECTED') {
            console.log("Already connected");
            self.$data.stompClient.subscribe('/topic/messages/order',
              function(messageOutput) {
              self.handleNotificationReceived(messageOutput);
              });
          } else {

            console.log("Not connected so try to connect");
            this.$data.stompClient.connect({}, function (frame) {

              self.handleMessageReceipt("Connected");
              self.$data.stompClient.subscribe('/topic/messages/order',
                function (messageOutput) {
                  self.handleNotificationReceived(messageOutput.body);
                });
            }, function (frame) {
              console.log("Connect error ");
              console.log(frame);
              setTimeout(self.setWebsocketConnection, 1000);
            });
          }
        },
        disconnectWebsocket: function(){
          console.log("disconnect socket")
          this.$data.disconnectSocket = true;
          if(this.$data.stompClient != null) {
            this.$data.stompClient.disconnect();
          }
          this.handleMessageReceipt("Disconnected");
        },

      }

    }
</script>

<style scoped>
.stick-top-row > th {
  position: sticky;
  top:0;
  background: #eee;
}
.item-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 90%;
  height: 90%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background: white;
}
.item-wrapper .item-header {
  height: 50px;
  padding: 10px;
  width: 100%;
}
.item-wrapper .item-body {
  height: calc(100% - 50px);
  width: 100%;
  padding: 0 10px 10px 10px;
  overflow-y: auto;
}
.category-title {
  font-size: 20px;
  font-weight: bold;
  padding-top: 30px;
  background: #FFEDFE;
}
.warning-input {
  background-color: red;
  color: white;
}
.partial-confirmed {
  background: #f4d03f;
}
.full-confirmed {
  background: #99daff;
}
.order-confirmed {
  background: #ccc;
}
.order-info-table {

}
.order-info-table td {
  padding: 5px 10px;
}
.order-info-table tr td:nth-child(1) {
  font-weight: bold;
}
.order-info-table select {
  padding: 5px 10px;
  border: 1px solid #ccc;
}
.order-info-table input {
  padding: 5px 10px;
  border: 1px solid #ccc;
}
.driver-selector {
  padding: 5px 10px;
  border: 1px solid #dadada;
}
.no-picked {
  color: #fff;
  background: #e7344c;

}
.less-picked {
  color: #000;
  background: #f7a70a;

}
.full-picked {
  color: white;
  background: #2fac66;
}
</style>



// WEBPACK FOOTER //
// src/components/Orders.vue